import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment as env } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { first, map, tap } from 'rxjs/operators';
import { NameValuePair } from '../../data-models/name-value-pair';
import { StdObj } from '../../data-models/standard-objects';
import { LgvModel } from '../../data-models/longevity.model';
import { LgvTSHelper } from '../utility/ts-helper';
import { LgvLoanApp } from '../../data-models/lgv-loan-application.model';
import { LgvFormlyModel } from '../../data-models/formly.model';
import { LgvPricingModel } from '../../features/pricing/models/pricing.model';


@Injectable({
    providedIn: 'root'
})


export class LgvMockDataService {

    //#region Constructior

    constructor() {

    }
    //#endregion Constructior

    //#region Sample Client Data

    mockClients(ownerId: string): any[] {
        let clientSuffix: number = Math.round(Math.random() * 10000);

        return [
            {
                clientBody: { "firstName": "John", "lastName": "Doe", "ownerId": '', "email": `John.Doe.${clientSuffix}@sample.data`, "mobilePhone": 9255195761 },
                propertyBody: { "address": "152 ESTHER LN", "city": "DANVILLE", "state": "CA", "zip": "94526", "county": "CONTRA COSTA", "propertyAssociationTypeId": "AB372ABD-ABAF-EC11-8CC9-000C290D53A0", "listingPrice": 1, "primaryProperty": true, "propertyValuationId": "10186177" }
            },
            {
                clientBody: { "firstName": "Jane", "lastName": "Doe", "ownerId": '', "email": `Jane.Doe.${clientSuffix}@sample.data`, "mobilePhone": 9257832259 },
                propertyBody: { "address": "173 VIA SERENA", "city": "ALAMO", "state": "CA", "zip": "94507", "county": "CONTRA COSTA", "propertyAssociationTypeId": "AB372ABD-ABAF-EC11-8CC9-000C290D53A0", "listingPrice": 1, "primaryProperty": true, "propertyValuationId": "10185183" }
            },
            {
                clientBody: { "firstName": "Mary", "lastName": "Smith", "ownerId": '', "email": `Mary.Smith.${clientSuffix}@sample.data`, "mobilePhone": 9255568468 },
                propertyBody: { "address": "1549 Via Romero", "city": "Alamo", "state": "CA", "zip": "94507", "county": "CONTRA COSTA", "propertyAssociationTypeId": "AB372ABD-ABAF-EC11-8CC9-000C290D53A0", "listingPrice": 1, "primaryProperty": true, "propertyValuationId": "10125292" }
            },
            {
                clientBody: { "firstName": "Dan", "lastName": "Aurbach", "ownerId": '', "email": `Dan.Aurbach.${clientSuffix}@sample.data`, "mobilePhone": 938569637 },
                propertyBody: { "address": "5742 MORAGA AVE", "city": "PIEDMONT", "state": "CA", "zip": "94611", "county": "ALAMEDA", "propertyAssociationTypeId": "AB372ABD-ABAF-EC11-8CC9-000C290D53A0", "listingPrice": 1, "primaryProperty": true, "propertyValuationId": "9479564" }
            }
        ]
    }

    mockAgentactivities(clientData: LgvModel.ClientInfo[], agent: LgvModel.AgentDTO) {

        let mockActivities = [];

        for (let client of clientData) {
            mockActivities.push(this.mockActivity(client, agent));
        }

        let rtnVal = {
            "totalEmailsSent": 0,
            "totalClientVisits": 15,
            "totalActivities": 4,
            "count": 4,
            "value": mockActivities
        };


        return rtnVal;

    }

    mockActivity(client: LgvModel.ClientInfo, agent: LgvModel.AgentDTO) {

        let randomDaysAgo = Math.floor(Math.random() * 10);
        let randomLogins = Math.floor(Math.random() * 10);
        let randomMyHome = Math.floor(Math.random() * 10);
        let randomEquity = Math.floor(Math.random() * 10);


        var activityDate = new Date();
        activityDate.setDate(activityDate.getDate() - randomDaysAgo);

        return {
            "clientId": client.id,
            "clientFirstName": client.firstName,
            "clientLastName": client.lastName,
            "clientTypes": [
                "Owned"
            ],
            "loanAgentId": agent.agentInfo.id,
            "loanAgentFirstname": agent.agentInfo.firstName,
            "loanAgentLastName": agent.agentInfo.lastName,
            "loanAgentOrganizationId": "",
            "loanAgentOrganizationName": null,
            "loanAgentCompanyId": "",
            "loanAgentCompanName": null,
            "realtorId": null,
            "realtorFirstName": null,
            "realtorLastName": null,
            "realtorOrganizationId": null,
            "realtorOrganizationName": null,
            "realtorCompanyId": null,
            "realtorCompanyName": null,
            "address": null,
            "city": null,
            "state": null,
            "zip": null,
            "equity": 175000,
            "equityPercent": 30 - randomEquity,
            "rate": 3 + (randomEquity * .375), // generate a random fake pct over 3%
            "loanTerm": null,
            "lienType": null,
            "closingDate": null,
            "isCobrandedClient": false,
            "latestActivityTimestamp": LgvTSHelper.jsDateToJsonDate(activityDate),
            "relevantCount": 0,
            "activitiesCount": 1 + randomLogins + randomMyHome,
            "activities": [
                {
                    "activityName": "Cur Loan: 03/24/23 6.8%  -  Public Loan: 10/09/22 4.5% ",
                    "count": 1,
                    "isRelevant": false
                },
                {
                    "activityName": "Log in ",
                    "count": randomLogins,
                    "isRelevant": false
                },
                {
                    "activityName": "My Home ",
                    "count": randomMyHome,
                    "isRelevant": false
                }
            ]
        }

    }


    //#endregion Sample Client Data

    //#region QuickPricer
    qpProducts(): any[] {
        return [
            {
                "amortizationTerm": "30",
                "amortizationType": "ARM",
                "apr": 7.703,
                "armIndex": "5.31495",
                "armMargin": 2.75,
                "armsubsequentChangePeriod": "6",
                "closingCost": 2648,
                "discount": 0,
                "investor": "Mega Capital Funding",
                "investorId": 0,
                "lastUpdate": null,
                "loanTerm": "30",
                "loanType": "Conventional",
                "lockPeriod": 30,
                "monthlyMi": 0,
                "pendingUpdate": false,
                "price": 100.074,
                "priceStatus": null,
                "principalAndInterest": 2796.86,
                "productCode": null,
                "productId": "MegaCapitalFunding-SilverJumbo10/6ARM",
                "productName": "Mega Capital Funding - Silver Jumbo 10/6 ARM",
                "rate": 7.5,
                "rebate": 295.99999999999227,
                "totalPayment": 2796.86,
                "guidelines": null,
                "productQuote": {
                    "productName": "Mega Capital Funding - Silver Jumbo 10/6 ARM",
                    "quotes": [
                        {
                            "rate": 8,
                            "lockPeriod": 30,
                            "lockExpirationDate": "2023-10-22T22:20:23.3036903Z",
                            "apr": 7.9742,
                            "price": 100.75,
                            "armMargin": null,
                            "closingCost": -56,
                            "discountDollar": null,
                            "discountPercent": null,
                            "rebateDollar": 3000,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2935.06,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2935.06,
                            "borrowerPaidDetails": [
                                {
                                    "amount": -3000,
                                    "description": "Origination : -0.750 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": -0.75,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": null,
                            "adjustedFee": null,
                            "computedApr": null,
                            "originalApr": 7.9742
                        },
                        {
                            "rate": 7.875,
                            "lockPeriod": 30,
                            "lockExpirationDate": "2023-10-22T22:20:23.3036931Z",
                            "apr": 7.8939,
                            "price": 100.699,
                            "armMargin": null,
                            "closingCost": 148,
                            "discountDollar": null,
                            "discountPercent": null,
                            "rebateDollar": 2795.9999999999923,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2900.2799999999997,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2900.28,
                            "borrowerPaidDetails": [
                                {
                                    "amount": -2796,
                                    "description": "Origination : -0.699 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": -0.699,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": null,
                            "adjustedFee": null,
                            "computedApr": null,
                            "originalApr": 7.8939
                        },
                        {
                            "rate": 7.75,
                            "lockPeriod": 30,
                            "lockExpirationDate": "2023-10-22T22:20:23.3036959Z",
                            "apr": 7.8215,
                            "price": 100.574,
                            "armMargin": null,
                            "closingCost": 648,
                            "discountDollar": null,
                            "discountPercent": null,
                            "rebateDollar": 2295.9999999999923,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2865.65,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2865.65,
                            "borrowerPaidDetails": [
                                {
                                    "amount": -2296,
                                    "description": "Origination : -0.574 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": -0.574,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": null,
                            "adjustedFee": null,
                            "computedApr": null,
                            "originalApr": 7.8215
                        },
                        {
                            "rate": 7.625,
                            "lockPeriod": 30,
                            "lockExpirationDate": "2023-10-22T22:20:23.3036984Z",
                            "apr": 7.7622,
                            "price": 100.324,
                            "armMargin": null,
                            "closingCost": 1648,
                            "discountDollar": null,
                            "discountPercent": null,
                            "rebateDollar": 1295.9999999999923,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2831.17,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2831.17,
                            "borrowerPaidDetails": [
                                {
                                    "amount": -1296,
                                    "description": "Origination : -0.324 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": -0.324,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": null,
                            "adjustedFee": null,
                            "computedApr": null,
                            "originalApr": 7.7622
                        },
                        {
                            "rate": 7.5,
                            "lockPeriod": 30,
                            "lockExpirationDate": "2023-10-22T22:20:23.303701Z",
                            "apr": 7.703,
                            "price": 100.074,
                            "armMargin": null,
                            "closingCost": 2648,
                            "discountDollar": null,
                            "discountPercent": null,
                            "rebateDollar": 295.99999999999227,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2796.86,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2796.86,
                            "borrowerPaidDetails": [
                                {
                                    "amount": -296,
                                    "description": "Origination : -0.074 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": -0.074,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": null,
                            "adjustedFee": null,
                            "computedApr": null,
                            "originalApr": 7.703
                        },
                        {
                            "rate": 7.375,
                            "lockPeriod": 30,
                            "lockExpirationDate": "2023-10-22T22:20:23.3037048Z",
                            "apr": 7.45,
                            "price": 99.699,
                            "armMargin": null,
                            "closingCost": 4148,
                            "discountDollar": 1204.0000000000077,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2762.7,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2762.7,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 1204,
                                    "description": "Origination : 0.301 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.301,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 7.45,
                            "adjustedFee": null,
                            "computedApr": 7.481,
                            "originalApr": 7.6566
                        },
                        {
                            "rate": 7.25,
                            "lockPeriod": 30,
                            "lockExpirationDate": "2023-10-22T22:20:23.3037075Z",
                            "apr": 7.33,
                            "price": 99.324,
                            "armMargin": null,
                            "closingCost": 5648,
                            "discountDollar": 2704.0000000000077,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2728.71,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2728.71,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 2704,
                                    "description": "Origination : 0.676 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.676,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 7.33,
                            "adjustedFee": null,
                            "computedApr": 7.394,
                            "originalApr": 7.6103
                        },
                        {
                            "rate": 7.125,
                            "lockPeriod": 30,
                            "lockExpirationDate": "2023-10-22T22:20:23.3037101Z",
                            "apr": 7.255,
                            "price": 98.824,
                            "armMargin": null,
                            "closingCost": 7648,
                            "discountDollar": 4704.000000000007,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2694.87,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2694.87,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 4704,
                                    "description": "Origination : 1.176 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.176,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 7.255,
                            "adjustedFee": null,
                            "computedApr": 7.319,
                            "originalApr": 7.5768
                        },
                        {
                            "rate": 7,
                            "lockPeriod": 30,
                            "lockExpirationDate": "2023-10-22T22:20:23.3037131Z",
                            "apr": 7.18,
                            "price": 98.324,
                            "armMargin": null,
                            "closingCost": 9648,
                            "discountDollar": 6704.000000000007,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2661.21,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2661.21,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 6704,
                                    "description": "Origination : 1.676 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.676,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 7.18,
                            "adjustedFee": null,
                            "computedApr": 7.244,
                            "originalApr": 7.5432
                        },
                        {
                            "rate": 8,
                            "lockPeriod": 45,
                            "lockExpirationDate": "2023-11-06T22:20:23.3037154Z",
                            "apr": 7.9795,
                            "price": 100.699,
                            "armMargin": null,
                            "closingCost": 148,
                            "discountDollar": null,
                            "discountPercent": null,
                            "rebateDollar": 2795.9999999999923,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2935.06,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2935.06,
                            "borrowerPaidDetails": [
                                {
                                    "amount": -2796,
                                    "description": "Origination : -0.699 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": -0.699,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": null,
                            "adjustedFee": null,
                            "computedApr": null,
                            "originalApr": 7.9795
                        },
                        {
                            "rate": 7.875,
                            "lockPeriod": 45,
                            "lockExpirationDate": "2023-11-06T22:20:23.3037179Z",
                            "apr": 7.9068,
                            "price": 100.574,
                            "armMargin": null,
                            "closingCost": 648,
                            "discountDollar": null,
                            "discountPercent": null,
                            "rebateDollar": 2295.9999999999923,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2900.2799999999997,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2900.28,
                            "borrowerPaidDetails": [
                                {
                                    "amount": -2296,
                                    "description": "Origination : -0.574 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": -0.574,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": null,
                            "adjustedFee": null,
                            "computedApr": null,
                            "originalApr": 7.9068
                        },
                        {
                            "rate": 7.75,
                            "lockPeriod": 45,
                            "lockExpirationDate": "2023-11-06T22:20:23.3037205Z",
                            "apr": 7.8344,
                            "price": 100.449,
                            "armMargin": null,
                            "closingCost": 1148,
                            "discountDollar": null,
                            "discountPercent": null,
                            "rebateDollar": 1795.9999999999925,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2865.65,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2865.65,
                            "borrowerPaidDetails": [
                                {
                                    "amount": -1796,
                                    "description": "Origination : -0.449 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": -0.449,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": null,
                            "adjustedFee": null,
                            "computedApr": null,
                            "originalApr": 7.8344
                        },
                        {
                            "rate": 7.625,
                            "lockPeriod": 45,
                            "lockExpirationDate": "2023-11-06T22:20:23.3037228Z",
                            "apr": 7.775,
                            "price": 100.199,
                            "armMargin": null,
                            "closingCost": 2148,
                            "discountDollar": null,
                            "discountPercent": null,
                            "rebateDollar": 795.9999999999922,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2831.17,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2831.17,
                            "borrowerPaidDetails": [
                                {
                                    "amount": -796,
                                    "description": "Origination : -0.199 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": -0.199,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": null,
                            "adjustedFee": null,
                            "computedApr": null,
                            "originalApr": 7.775
                        },
                        {
                            "rate": 7.5,
                            "lockPeriod": 45,
                            "lockExpirationDate": "2023-11-06T22:20:23.303725Z",
                            "apr": 7.576,
                            "price": 99.949,
                            "armMargin": null,
                            "closingCost": 3148,
                            "discountDollar": 204.00000000000773,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2796.86,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2796.86,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 204,
                                    "description": "Origination : 0.051 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.051,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 7.576,
                            "adjustedFee": null,
                            "computedApr": 7.581,
                            "originalApr": 7.7158
                        },
                        {
                            "rate": 7.375,
                            "lockPeriod": 45,
                            "lockExpirationDate": "2023-11-06T22:20:23.3037272Z",
                            "apr": 7.45,
                            "price": 99.574,
                            "armMargin": null,
                            "closingCost": 4648,
                            "discountDollar": 1704.0000000000075,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2762.7,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2762.7,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 1704,
                                    "description": "Origination : 0.426 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.426,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 7.45,
                            "adjustedFee": null,
                            "computedApr": 7.494,
                            "originalApr": 7.6694
                        },
                        {
                            "rate": 7.25,
                            "lockPeriod": 45,
                            "lockExpirationDate": "2023-11-06T22:20:23.303731Z",
                            "apr": 7.342,
                            "price": 99.199,
                            "armMargin": null,
                            "closingCost": 6148,
                            "discountDollar": 3204.0000000000077,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2728.71,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2728.71,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 3204,
                                    "description": "Origination : 0.801 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.801,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 7.342,
                            "adjustedFee": null,
                            "computedApr": 7.407,
                            "originalApr": 7.6231
                        },
                        {
                            "rate": 7.125,
                            "lockPeriod": 45,
                            "lockExpirationDate": "2023-11-06T22:20:23.3037335Z",
                            "apr": 7.268,
                            "price": 98.699,
                            "armMargin": null,
                            "closingCost": 8148,
                            "discountDollar": 5204.000000000008,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2694.87,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2694.87,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 5204,
                                    "description": "Origination : 1.301 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.301,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 7.268,
                            "adjustedFee": null,
                            "computedApr": 7.332,
                            "originalApr": 7.5895
                        },
                        {
                            "rate": 7,
                            "lockPeriod": 45,
                            "lockExpirationDate": "2023-11-06T22:20:23.3037359Z",
                            "apr": 7.192,
                            "price": 98.199,
                            "armMargin": null,
                            "closingCost": 10148,
                            "discountDollar": 7204.000000000007,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2661.21,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2661.21,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 7204,
                                    "description": "Origination : 1.801 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.801,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 7.192,
                            "adjustedFee": null,
                            "computedApr": 7.257,
                            "originalApr": 7.556
                        },
                        {
                            "rate": 8,
                            "lockPeriod": 60,
                            "lockExpirationDate": "2023-11-21T22:20:23.3037387Z",
                            "apr": 8.0057,
                            "price": 100.449,
                            "armMargin": null,
                            "closingCost": 1148,
                            "discountDollar": null,
                            "discountPercent": null,
                            "rebateDollar": 1795.9999999999925,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2935.06,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2935.06,
                            "borrowerPaidDetails": [
                                {
                                    "amount": -1796,
                                    "description": "Origination : -0.449 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": -0.449,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": null,
                            "adjustedFee": null,
                            "computedApr": null,
                            "originalApr": 8.0057
                        },
                        {
                            "rate": 7.875,
                            "lockPeriod": 60,
                            "lockExpirationDate": "2023-11-21T22:20:23.3037412Z",
                            "apr": 7.9329,
                            "price": 100.324,
                            "armMargin": null,
                            "closingCost": 1648,
                            "discountDollar": null,
                            "discountPercent": null,
                            "rebateDollar": 1295.9999999999923,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2900.2799999999997,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2900.28,
                            "borrowerPaidDetails": [
                                {
                                    "amount": -1296,
                                    "description": "Origination : -0.324 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": -0.324,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": null,
                            "adjustedFee": null,
                            "computedApr": null,
                            "originalApr": 7.9329
                        },
                        {
                            "rate": 7.75,
                            "lockPeriod": 60,
                            "lockExpirationDate": "2023-11-21T22:20:23.3037435Z",
                            "apr": 7.8603,
                            "price": 100.199,
                            "armMargin": null,
                            "closingCost": 2148,
                            "discountDollar": null,
                            "discountPercent": null,
                            "rebateDollar": 795.9999999999922,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2865.65,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2865.65,
                            "borrowerPaidDetails": [
                                {
                                    "amount": -796,
                                    "description": "Origination : -0.199 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": -0.199,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": null,
                            "adjustedFee": null,
                            "computedApr": null,
                            "originalApr": 7.8603
                        },
                        {
                            "rate": 7.625,
                            "lockPeriod": 60,
                            "lockExpirationDate": "2023-11-21T22:20:23.3037465Z",
                            "apr": 7.701,
                            "price": 99.949,
                            "armMargin": null,
                            "closingCost": 3148,
                            "discountDollar": 204.00000000000773,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2831.17,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2831.17,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 204,
                                    "description": "Origination : 0.051 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.051,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 7.701,
                            "adjustedFee": null,
                            "computedApr": 7.706,
                            "originalApr": 7.8008
                        },
                        {
                            "rate": 7.5,
                            "lockPeriod": 60,
                            "lockExpirationDate": "2023-11-21T22:20:23.3037489Z",
                            "apr": 7.576,
                            "price": 99.699,
                            "armMargin": null,
                            "closingCost": 4148,
                            "discountDollar": 1204.0000000000077,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2796.86,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2796.86,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 1204,
                                    "description": "Origination : 0.301 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.301,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 7.576,
                            "adjustedFee": null,
                            "computedApr": 7.607,
                            "originalApr": 7.7414
                        },
                        {
                            "rate": 7.375,
                            "lockPeriod": 60,
                            "lockExpirationDate": "2023-11-21T22:20:23.3037514Z",
                            "apr": 7.455,
                            "price": 99.324,
                            "armMargin": null,
                            "closingCost": 5648,
                            "discountDollar": 2704.0000000000077,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2762.7,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2762.7,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 2704,
                                    "description": "Origination : 0.676 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.676,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 7.455,
                            "adjustedFee": null,
                            "computedApr": 7.52,
                            "originalApr": 7.695
                        },
                        {
                            "rate": 7.25,
                            "lockPeriod": 60,
                            "lockExpirationDate": "2023-11-21T22:20:23.3037554Z",
                            "apr": 7.368,
                            "price": 98.949,
                            "armMargin": null,
                            "closingCost": 7148,
                            "discountDollar": 4204.000000000007,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2728.71,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2728.71,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 4204,
                                    "description": "Origination : 1.051 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.051,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 7.368,
                            "adjustedFee": null,
                            "computedApr": 7.432,
                            "originalApr": 7.6486
                        },
                        {
                            "rate": 7.125,
                            "lockPeriod": 60,
                            "lockExpirationDate": "2023-11-21T22:20:23.3037576Z",
                            "apr": 7.293,
                            "price": 98.449,
                            "armMargin": null,
                            "closingCost": 9148,
                            "discountDollar": 6204.000000000007,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 2694.87,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 2694.87,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 6204,
                                    "description": "Origination : 1.551 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.551,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 7.293,
                            "adjustedFee": null,
                            "computedApr": 7.358,
                            "originalApr": 7.6151
                        }
                    ],
                    "searchId": null,
                    "productId": "MegaCapitalFunding-SilverJumbo10/6ARM",
                    "totalRateAdjustment": null,
                    "totalPriceAdjustment": null,
                    "totalSRPAdjustment": null,
                    "totalMarginAdjustment": null,
                    "notesAndAdvisories": null,
                    "armSubsequentChangePeriod": null,
                    "armIndex": null,
                    "armIndexValue": null,
                    "armFirstCap": null,
                    "armPeriodicCap": null,
                    "armFixedTerm": null,
                    "armLifetimeCap": null,
                    "armRelativeCap": null,
                    "constructionTermMonths": null,
                    "originationFees": null,
                    "investorId": null,
                    "miRequiredOver80Ltv": null,
                    "interestOnlyTerm": null
                },
                "keyLabel": "10/6 30 Year Variable Conventional Purchase",
                "programName": "Silver Jumbo 10/6 ARM",
            },
            {
                "amortizationTerm": "15",
                "amortizationType": "Fixed",
                "apr": 6.4841,
                "armIndex": "0",
                "armMargin": 0,
                "armsubsequentChangePeriod": null,
                "closingCost": 4444,
                "discount": 1500,
                "investor": "Provident Funding",
                "investorId": 0,
                "lastUpdate": null,
                "loanTerm": "15",
                "loanType": "Conventional",
                "lockPeriod": 30,
                "monthlyMi": 0,
                "pendingUpdate": false,
                "price": 99.625,
                "priceStatus": null,
                "principalAndInterest": 3457,
                "productCode": null,
                "productId": "ProvidentFunding-DU15Yr-A1020",
                "productName": "Provident Funding - DU 15 Yr - A1020",
                "rate": 6.375,
                "rebate": 0,
                "totalPayment": 3457,
                "guidelines": null,
                "productQuote": {
                    "productName": "Provident Funding - DU 15 Yr - A1020",
                    "quotes": [
                        {
                            "rate": 6.375,
                            "lockPeriod": 12,
                            "lockExpirationDate": "2023-10-04T22:20:23.2878342Z",
                            "apr": 6.492,
                            "price": 99.875,
                            "armMargin": null,
                            "closingCost": 3444,
                            "discountDollar": 500,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3457,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3457,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 500,
                                    "description": "Origination : 0.125 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.125,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.492,
                            "adjustedFee": null,
                            "computedApr": 6.512,
                            "originalApr": 6.4443
                        },
                        {
                            "rate": 6.25,
                            "lockPeriod": 12,
                            "lockExpirationDate": "2023-10-04T22:20:23.2878369Z",
                            "apr": 6.366,
                            "price": 99.5,
                            "armMargin": null,
                            "closingCost": 4944,
                            "discountDollar": 2000,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3429.6899999999996,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3429.69,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 2000,
                                    "description": "Origination : 0.500 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.5,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.366,
                            "adjustedFee": null,
                            "computedApr": 6.446,
                            "originalApr": 6.3786
                        },
                        {
                            "rate": 6.125,
                            "lockPeriod": 12,
                            "lockExpirationDate": "2023-10-04T22:20:23.287839Z",
                            "apr": 6.261,
                            "price": 99.25,
                            "armMargin": null,
                            "closingCost": 5944,
                            "discountDollar": 3000,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3402.5,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3402.5,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 3000,
                                    "description": "Origination : 0.750 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.75,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.261,
                            "adjustedFee": null,
                            "computedApr": 6.36,
                            "originalApr": 6.2928
                        },
                        {
                            "rate": 6,
                            "lockPeriod": 12,
                            "lockExpirationDate": "2023-10-04T22:20:23.2878415Z",
                            "apr": 6.195,
                            "price": 98.875,
                            "armMargin": null,
                            "closingCost": 7444,
                            "discountDollar": 4500,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3375.4300000000003,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3375.43,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 4500,
                                    "description": "Origination : 1.125 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.125,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.195,
                            "adjustedFee": null,
                            "computedApr": 6.295,
                            "originalApr": 6.2269
                        },
                        {
                            "rate": 5.875,
                            "lockPeriod": 12,
                            "lockExpirationDate": "2023-10-04T22:20:23.287844Z",
                            "apr": 6.109,
                            "price": 98.625,
                            "armMargin": null,
                            "closingCost": 8444,
                            "discountDollar": 5500,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3348.4700000000003,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3348.47,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 5500,
                                    "description": "Origination : 1.375 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.375,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.109,
                            "adjustedFee": null,
                            "computedApr": 6.209,
                            "originalApr": 6.1409
                        },
                        {
                            "rate": 5.75,
                            "lockPeriod": 12,
                            "lockExpirationDate": "2023-10-04T22:20:23.2878465Z",
                            "apr": 6.023,
                            "price": 98.375,
                            "armMargin": null,
                            "closingCost": 9444,
                            "discountDollar": 6500,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3321.6400000000003,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3321.64,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 6500,
                                    "description": "Origination : 1.625 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.625,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.023,
                            "adjustedFee": null,
                            "computedApr": 6.123,
                            "originalApr": 6.0547
                        },
                        {
                            "rate": 5.625,
                            "lockPeriod": 12,
                            "lockExpirationDate": "2023-10-04T22:20:23.2878504Z",
                            "apr": 5.956,
                            "price": 98,
                            "armMargin": null,
                            "closingCost": 10944,
                            "discountDollar": 8000,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3294.9300000000003,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3294.93,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 8000,
                                    "description": "Origination : 2.000 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 2,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 5.956,
                            "adjustedFee": null,
                            "computedApr": 6.056,
                            "originalApr": 5.9884
                        },
                        {
                            "rate": 6.375,
                            "lockPeriod": 21,
                            "lockExpirationDate": "2023-10-13T22:20:23.2878531Z",
                            "apr": 6.492,
                            "price": 99.75,
                            "armMargin": null,
                            "closingCost": 3944,
                            "discountDollar": 1000,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3457,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3457,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 1000,
                                    "description": "Origination : 0.250 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.25,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.492,
                            "adjustedFee": null,
                            "computedApr": 6.532,
                            "originalApr": 6.4642
                        },
                        {
                            "rate": 6.25,
                            "lockPeriod": 21,
                            "lockExpirationDate": "2023-10-13T22:20:23.2878558Z",
                            "apr": 6.366,
                            "price": 99.375,
                            "armMargin": null,
                            "closingCost": 5444,
                            "discountDollar": 2500,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3429.6899999999996,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3429.69,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 2500,
                                    "description": "Origination : 0.625 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.625,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.366,
                            "adjustedFee": null,
                            "computedApr": 6.466,
                            "originalApr": 6.3985
                        },
                        {
                            "rate": 6.125,
                            "lockPeriod": 21,
                            "lockExpirationDate": "2023-10-13T22:20:23.2878585Z",
                            "apr": 6.281,
                            "price": 99.125,
                            "armMargin": null,
                            "closingCost": 6444,
                            "discountDollar": 3500.0000000000005,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3402.5,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3402.5,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 3500,
                                    "description": "Origination : 0.875 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.875,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.281,
                            "adjustedFee": null,
                            "computedApr": 6.381,
                            "originalApr": 6.3128
                        },
                        {
                            "rate": 6,
                            "lockPeriod": 21,
                            "lockExpirationDate": "2023-10-13T22:20:23.2878609Z",
                            "apr": 6.215,
                            "price": 98.75,
                            "armMargin": null,
                            "closingCost": 7944,
                            "discountDollar": 5000,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3375.4300000000003,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3375.43,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 5000,
                                    "description": "Origination : 1.250 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.25,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.215,
                            "adjustedFee": null,
                            "computedApr": 6.315,
                            "originalApr": 6.2469
                        },
                        {
                            "rate": 5.875,
                            "lockPeriod": 21,
                            "lockExpirationDate": "2023-10-13T22:20:23.287863Z",
                            "apr": 6.129,
                            "price": 98.5,
                            "armMargin": null,
                            "closingCost": 8944,
                            "discountDollar": 6000,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3348.4700000000003,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3348.47,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 6000,
                                    "description": "Origination : 1.500 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.5,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.129,
                            "adjustedFee": null,
                            "computedApr": 6.229,
                            "originalApr": 6.1608
                        },
                        {
                            "rate": 5.75,
                            "lockPeriod": 21,
                            "lockExpirationDate": "2023-10-13T22:20:23.2878654Z",
                            "apr": 6.043,
                            "price": 98.25,
                            "armMargin": null,
                            "closingCost": 9944,
                            "discountDollar": 7000.000000000001,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3321.6400000000003,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3321.64,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 7000,
                                    "description": "Origination : 1.750 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.75,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.043,
                            "adjustedFee": null,
                            "computedApr": 6.143,
                            "originalApr": 6.0747
                        },
                        {
                            "rate": 6.375,
                            "lockPeriod": 30,
                            "lockExpirationDate": "2023-10-22T22:20:23.2878675Z",
                            "apr": 6.492,
                            "price": 99.625,
                            "armMargin": null,
                            "closingCost": 4444,
                            "discountDollar": 1500,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3457,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3457,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 1500,
                                    "description": "Origination : 0.375 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.375,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.492,
                            "adjustedFee": null,
                            "computedApr": 6.552,
                            "originalApr": 6.4841
                        },
                        {
                            "rate": 6.25,
                            "lockPeriod": 30,
                            "lockExpirationDate": "2023-10-22T22:20:23.2878692Z",
                            "apr": 6.386,
                            "price": 99.25,
                            "armMargin": null,
                            "closingCost": 5944,
                            "discountDollar": 3000,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3429.6899999999996,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3429.69,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 3000,
                                    "description": "Origination : 0.750 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.75,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.386,
                            "adjustedFee": null,
                            "computedApr": 6.486,
                            "originalApr": 6.4185
                        },
                        {
                            "rate": 6.125,
                            "lockPeriod": 30,
                            "lockExpirationDate": "2023-10-22T22:20:23.287872Z",
                            "apr": 6.301,
                            "price": 99,
                            "armMargin": null,
                            "closingCost": 6944,
                            "discountDollar": 4000,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3402.5,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3402.5,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 4000,
                                    "description": "Origination : 1.000 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.301,
                            "adjustedFee": null,
                            "computedApr": 6.401,
                            "originalApr": 6.3327
                        },
                        {
                            "rate": 6,
                            "lockPeriod": 30,
                            "lockExpirationDate": "2023-10-22T22:20:23.2878764Z",
                            "apr": 6.235,
                            "price": 98.625,
                            "armMargin": null,
                            "closingCost": 8444,
                            "discountDollar": 5500,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3375.4300000000003,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3375.43,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 5500,
                                    "description": "Origination : 1.375 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.375,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.235,
                            "adjustedFee": null,
                            "computedApr": 6.335,
                            "originalApr": 6.2668
                        },
                        {
                            "rate": 5.875,
                            "lockPeriod": 30,
                            "lockExpirationDate": "2023-10-22T22:20:23.2878793Z",
                            "apr": 6.149,
                            "price": 98.375,
                            "armMargin": null,
                            "closingCost": 9444,
                            "discountDollar": 6500,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3348.4700000000003,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3348.47,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 6500,
                                    "description": "Origination : 1.625 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.625,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.149,
                            "adjustedFee": null,
                            "computedApr": 6.249,
                            "originalApr": 6.1808
                        },
                        {
                            "rate": 5.75,
                            "lockPeriod": 30,
                            "lockExpirationDate": "2023-10-22T22:20:23.2878817Z",
                            "apr": 6.062,
                            "price": 98.125,
                            "armMargin": null,
                            "closingCost": 10444,
                            "discountDollar": 7500,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3321.6400000000003,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3321.64,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 7500,
                                    "description": "Origination : 1.875 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.875,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.062,
                            "adjustedFee": null,
                            "computedApr": 6.163,
                            "originalApr": 6.0947
                        },
                        {
                            "rate": 6.375,
                            "lockPeriod": 45,
                            "lockExpirationDate": "2023-11-06T22:20:23.2878845Z",
                            "apr": 6.492,
                            "price": 99.5,
                            "armMargin": null,
                            "closingCost": 4944,
                            "discountDollar": 2000,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3457,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3457,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 2000,
                                    "description": "Origination : 0.500 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.5,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.492,
                            "adjustedFee": null,
                            "computedApr": 6.572,
                            "originalApr": 6.504
                        },
                        {
                            "rate": 6.25,
                            "lockPeriod": 45,
                            "lockExpirationDate": "2023-11-06T22:20:23.2878869Z",
                            "apr": 6.406,
                            "price": 99.125,
                            "armMargin": null,
                            "closingCost": 6444,
                            "discountDollar": 3500.0000000000005,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3429.6899999999996,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3429.69,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 3500,
                                    "description": "Origination : 0.875 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.875,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.406,
                            "adjustedFee": null,
                            "computedApr": 6.506,
                            "originalApr": 6.4384
                        },
                        {
                            "rate": 6.125,
                            "lockPeriod": 45,
                            "lockExpirationDate": "2023-11-06T22:20:23.2878893Z",
                            "apr": 6.321,
                            "price": 98.875,
                            "armMargin": null,
                            "closingCost": 7444,
                            "discountDollar": 4500,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3402.5,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3402.5,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 4500,
                                    "description": "Origination : 1.125 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.125,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.321,
                            "adjustedFee": null,
                            "computedApr": 6.421,
                            "originalApr": 6.3527
                        },
                        {
                            "rate": 6,
                            "lockPeriod": 45,
                            "lockExpirationDate": "2023-11-06T22:20:23.2878917Z",
                            "apr": 6.255,
                            "price": 98.5,
                            "armMargin": null,
                            "closingCost": 8944,
                            "discountDollar": 6000,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3375.4300000000003,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3375.43,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 6000,
                                    "description": "Origination : 1.500 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.5,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.255,
                            "adjustedFee": null,
                            "computedApr": 6.355,
                            "originalApr": 6.2869
                        },
                        {
                            "rate": 5.875,
                            "lockPeriod": 45,
                            "lockExpirationDate": "2023-11-06T22:20:23.2878941Z",
                            "apr": 6.169,
                            "price": 98.25,
                            "armMargin": null,
                            "closingCost": 9944,
                            "discountDollar": 7000.000000000001,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3348.4700000000003,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3348.47,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 7000,
                                    "description": "Origination : 1.750 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.75,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.169,
                            "adjustedFee": null,
                            "computedApr": 6.269,
                            "originalApr": 6.2009
                        },
                        {
                            "rate": 5.75,
                            "lockPeriod": 45,
                            "lockExpirationDate": "2023-11-06T22:20:23.2878968Z",
                            "apr": 6.082,
                            "price": 98,
                            "armMargin": null,
                            "closingCost": 10944,
                            "discountDollar": 8000,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3321.6400000000003,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3321.64,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 8000,
                                    "description": "Origination : 2.000 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 2,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.082,
                            "adjustedFee": null,
                            "computedApr": 6.183,
                            "originalApr": 6.1147
                        },
                        {
                            "rate": 6.375,
                            "lockPeriod": 60,
                            "lockExpirationDate": "2023-11-21T22:20:23.2878992Z",
                            "apr": 6.512,
                            "price": 99.25,
                            "armMargin": null,
                            "closingCost": 5944,
                            "discountDollar": 3000,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3457,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3457,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 3000,
                                    "description": "Origination : 0.750 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 0.75,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.512,
                            "adjustedFee": null,
                            "computedApr": 6.612,
                            "originalApr": 6.5441
                        },
                        {
                            "rate": 6.25,
                            "lockPeriod": 60,
                            "lockExpirationDate": "2023-11-21T22:20:23.287903Z",
                            "apr": 6.446,
                            "price": 98.875,
                            "armMargin": null,
                            "closingCost": 7444,
                            "discountDollar": 4500,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3429.6899999999996,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3429.69,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 4500,
                                    "description": "Origination : 1.125 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.125,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.446,
                            "adjustedFee": null,
                            "computedApr": 6.547,
                            "originalApr": 6.4785
                        },
                        {
                            "rate": 6.125,
                            "lockPeriod": 60,
                            "lockExpirationDate": "2023-11-21T22:20:23.2879054Z",
                            "apr": 6.36,
                            "price": 98.625,
                            "armMargin": null,
                            "closingCost": 8444,
                            "discountDollar": 5500,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3402.5,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3402.5,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 5500,
                                    "description": "Origination : 1.375 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.375,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.36,
                            "adjustedFee": null,
                            "computedApr": 6.461,
                            "originalApr": 6.3928
                        },
                        {
                            "rate": 6,
                            "lockPeriod": 60,
                            "lockExpirationDate": "2023-11-21T22:20:23.2879078Z",
                            "apr": 6.295,
                            "price": 98.25,
                            "armMargin": null,
                            "closingCost": 9944,
                            "discountDollar": 7000.000000000001,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3375.4300000000003,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3375.43,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 7000,
                                    "description": "Origination : 1.750 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 1.75,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.295,
                            "adjustedFee": null,
                            "computedApr": 6.395,
                            "originalApr": 6.3271
                        },
                        {
                            "rate": 5.875,
                            "lockPeriod": 60,
                            "lockExpirationDate": "2023-11-21T22:20:23.2879102Z",
                            "apr": 6.209,
                            "price": 98,
                            "armMargin": null,
                            "closingCost": 10944,
                            "discountDollar": 8000,
                            "discountPercent": null,
                            "rebateDollar": null,
                            "rebatePercent": null,
                            "loCompensationDollar": null,
                            "loCompensationPercent": null,
                            "principalAndInterest": 3348.4700000000003,
                            "totalCredit": null,
                            "monthlyMi": 0,
                            "totalPayment": 3348.47,
                            "borrowerPaidDetails": [
                                {
                                    "amount": 8000,
                                    "description": "Origination : 2.000 (Points) x $400,000.00 (Loan Amount)",
                                    "isOrigination": true,
                                    "points": 2,
                                    "type": "Origination"
                                },
                                {
                                    "amount": 1250,
                                    "description": "Underwriting",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                },
                                {
                                    "amount": 1595,
                                    "description": "Administration Fee",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Administration"
                                },
                                {
                                    "amount": 99,
                                    "description": "Credit Report",
                                    "isOrigination": false,
                                    "points": null,
                                    "type": "Fee"
                                }
                            ],
                            "adjustedApr": 6.209,
                            "adjustedFee": null,
                            "computedApr": 6.309,
                            "originalApr": 6.241
                        }
                    ],
                    "searchId": null,
                    "productId": "ProvidentFunding-DU15Yr-A1020",
                    "totalRateAdjustment": null,
                    "totalPriceAdjustment": null,
                    "totalSRPAdjustment": null,
                    "totalMarginAdjustment": null,
                    "notesAndAdvisories": null,
                    "armSubsequentChangePeriod": null,
                    "armIndex": null,
                    "armIndexValue": null,
                    "armFirstCap": null,
                    "armPeriodicCap": null,
                    "armFixedTerm": null,
                    "armLifetimeCap": null,
                    "armRelativeCap": null,
                    "constructionTermMonths": null,
                    "originationFees": null,
                    "investorId": null,
                    "miRequiredOver80Ltv": null,
                    "interestOnlyTerm": null
                },
                "keyLabel": "15 Year Fixed Conventional Purchase",
                "programName": "DU 15 Yr - A1020"
            }
        ]
    }
    //#endregion QuickPricer

    //#region Client Data
    public mockClientSnapshot(): Observable<LgvModel.ClientSnapshot> {
        return of(
            {
                id: "f686ec39-717a-ee11-8925-6045bd0209a4",
                clientInfo: {
                    id: "f686ec39-717a-ee11-8925-6045bd0209a4",
                    ownerId: "b9b89048-6d31-ee11-a9bb-000d3a37c80a",
                    clientType: null,
                    username: null,
                    firstName: "Peter",
                    lastName: "Gabriel",
                    nickName: null,
                    gender: null,
                    email: "pg@x.net",
                    homePhone: null,
                    workPhone: null,
                    mobilePhone: "55555555555",
                    fax: null,
                    birthDate: null,
                    totalIncome: 12000.00,
                    maritalStatus: null,
                    numberDependents: null,
                    dependentAges: null,
                    address1: null,
                    address2: null,
                    city: null,
                    state: null,
                    zipCode: null,
                    fico: 825,
                    isSubscribed: false,
                    serviceInterest: null,
                    isSilenced: false,
                    isArchived: false,
                    isDeleted: false,
                    externalId: null,
                    createdTimestamp: "2023-11-03T17:48:42.683",
                    updatedTimestamp: "2023-11-03T17:52:48.06",
                    identityServiceId: null,
                    registeredDate: null,
                    mailChimpStartDate: null,
                    mailChimpEmail: null,
                    previousMailChimpStartDate: null,
                    source: "Manual",
                    lastEmailReceivedDate: "2023-11-03T17:51:27.967",
                    firstTimeBuyer: false,
                    totalDebtPayments: 3000.00,
                    owner: null,
                    activities: [],
                    clientGoals: [],
                    clientNonHomeLoans: [],
                    clientProperties:[],
                    loanApplications: [],
                    loanScenarios: [],
                    nonHomeLoans: [],
                    opportunities: [],
                    pricingRequests: []
                },
                settings: {
                    pages: [
                        {
                            key: "my-loan",
                            title: "my-loan",
                            description: "my-loan",
                            displayOrder: 20,
                            isVisible: true,
                            contentTypeId: "dd9723cf-28d6-419a-957e-e2f17114ccd5",
                            contentTypeName: "Page"
                        },
                        {
                            key: "education",
                            title: "education",
                            description: "education",
                            displayOrder: 130,
                            isVisible: true,
                            contentTypeId: "dd9723cf-28d6-419a-957e-e2f17114ccd5",
                            contentTypeName: "Page"
                        },
                        {
                            key: "buyb4usell",
                            title: "buyb4usell",
                            description: "buyb4usell",
                            displayOrder: 70,
                            isVisible: true,
                            contentTypeId: "dd9723cf-28d6-419a-957e-e2f17114ccd5",
                            contentTypeName: "Page"
                        },
                        {
                            key: "special-offers",
                            title: "special-offers",
                            description: "special-offers",
                            displayOrder: 130,
                            isVisible: true,
                            contentTypeId: "dd9723cf-28d6-419a-957e-e2f17114ccd5",
                            contentTypeName: "Page"
                        },
                        {
                            key: "hippo",
                            title: "hippo",
                            description: "hippo",
                            displayOrder: 130,
                            isVisible: true,
                            contentTypeId: "dd9723cf-28d6-419a-957e-e2f17114ccd5",
                            contentTypeName: "Page"
                        },
                        {
                            key: "goals",
                            title: "goals",
                            description: "goals",
                            displayOrder: 60,
                            isVisible: true,
                            contentTypeId: "dd9723cf-28d6-419a-957e-e2f17114ccd5",
                            contentTypeName: "Page"
                        },
                        {
                            key: "my-home",
                            title: "my-home",
                            description: "my-home",
                            displayOrder: 30,
                            isVisible: true,
                            contentTypeId: "dd9723cf-28d6-419a-957e-e2f17114ccd5",
                            contentTypeName: "Page"
                        },
                        {
                            key: "refinance-options",
                            title: "refinance-options",
                            description: "refinance-options",
                            displayOrder: 40,
                            isVisible: true,
                            contentTypeId: "dd9723cf-28d6-419a-957e-e2f17114ccd5",
                            contentTypeName: "Page"
                        },
                        {
                            key: "rent-home-and-buy",
                            title: "rent-home-and-buy",
                            description: "rent-home-and-buy",
                            displayOrder: 110,
                            isVisible: true,
                            contentTypeId: "dd9723cf-28d6-419a-957e-e2f17114ccd5",
                            contentTypeName: "Page"
                        },
                        {
                            key: "sell-home-cashout",
                            title: "sell-home-cashout",
                            description: "sell-home-cashout",
                            displayOrder: 100,
                            isVisible: true,
                            contentTypeId: "dd9723cf-28d6-419a-957e-e2f17114ccd5",
                            contentTypeName: "Page"
                        },
                        {
                            key: "dashboard",
                            title: "dashboard",
                            description: "dashboard",
                            displayOrder: 10,
                            isVisible: true,
                            contentTypeId: "dd9723cf-28d6-419a-957e-e2f17114ccd5",
                            contentTypeName: "Page"
                        },
                        {
                            key: "new-home",
                            title: "new-home",
                            description: "new-home",
                            displayOrder: 90,
                            isVisible: true,
                            contentTypeId: "dd9723cf-28d6-419a-957e-e2f17114ccd5",
                            contentTypeName: "Page"
                        },
                        {
                            key: "listing-enhancement-loan",
                            title: "listing-enhancement-loan",
                            description: "listing-enhancement-loan",
                            displayOrder: 80,
                            isVisible: true,
                            contentTypeId: "dd9723cf-28d6-419a-957e-e2f17114ccd5",
                            contentTypeName: "Page"
                        },
                        {
                            key: "investment-property",
                            title: "investment-property",
                            description: "investment-property",
                            displayOrder: 120,
                            isVisible: true,
                            contentTypeId: "dd9723cf-28d6-419a-957e-e2f17114ccd5",
                            contentTypeName: "Page"
                        },
                        {
                            key: "request-cma",
                            title: "request-cma",
                            description: "request-cma",
                            displayOrder: 50,
                            isVisible: true,
                            contentTypeId: "dd9723cf-28d6-419a-957e-e2f17114ccd5",
                            contentTypeName: "Page"
                        }
                    ]
                },
                properties: [
                    {
                        propertyInfo: {
                            id: "f786ec39-717a-ee11-8925-6045bd0209a4",
                            address: "5792 UPLANDS RD",
                            city: "CARNELIAN BAY",
                            state: "CA",
                            zip: "96140",
                            propertyTypeId: null,
                            yearBuilt: 1967,
                            parcelNumber: null,
                            coreLogicPropertyId: null,
                            county: "PLACER",
                            ownerName: "Smith, CAROLINE",
                            avmestimatedValue: 896802.00,
                            avmlowValue: 762281.00,
                            avmhighValue: 1031322.00,
                            avmprocessedDate: "2023-10-25T00:00:00",
                            avmforecastStandardDeviation: 15.000,
                            apn: null,
                            landUse: null,
                            landUseCode: null,
                            censusTract: null,
                            absenteeOwner: null,
                            latitude: 39.235080,
                            longitude: -120.073852,
                            standardLandUse: null,
                            standardLandUseCode: null,
                            livingArea: 1288,
                            totalRooms: null,
                            bedrooms: 3,
                            fullBath: null,
                            halfBath: null,
                            totalBaths: 2.0,
                            pool: null,
                            numberOfStories: null,
                            lotArea: 14374,
                            effectiveYearBuilt: null,
                            airConditioning: null,
                            fireplace: 1,
                            parking: null,
                            propertyValuationId: "15672445",
                            propertyValuationIdSearchSuccessful: true,
                            lastPropertyValuationSearch: null,
                            clientEstimatedValue: null,
                            clientEstimatedValueDelta: null,
                            clientEstimatedValueUpdatedTimestamp: null,
                            clientEstimatedValueUpdatedBy: null,
                            marketValueHistoryUpdatedTimestamp: "2023-11-03T17:48:43.193",
                            createdTimestamp: "2023-11-03T17:48:42.877",
                            updatedTimestamp: null,
                            marketValueUpdatedTimestamp: "2023-11-03T17:48:43.31",
                            isMarketValueUpdatedByScheduler: false,
                            source: "Manual",
                            dataTracePropertyId: null,
                            qvmPropertyId: null,
                            qvmSearchTimestamp: "2023-11-03T17:48:42.877",
                            qvmSearchResultsCount: null,
                            sourceAddress: null,
                            sourceCity: null,
                            sourceState: null,
                            sourceZip: null,
                            sourceCounty: null,
                            lastPublicRecordCheckupDate: "2023-11-03T17:50:21.007",
                            basementArea: null,
                            zoning: "018",
                            neighborhoodName: "AGATE BAY UPLANDS",
                            schoolDistrict: "Tahoe-Truckee Unified School District",
                            elementarySchool: null,
                            middleSchool: null,
                            highSchool: null,
                            salePrice: 925000.00,
                            saleDate: "2023-08-21T00:00:00",
                            taxYear: 2022,
                            propertyTax: 7623.58,
                            assessedValue: 632597.00,
                            garage: "Garage",
                            garageParkingSpaceCount: 2,
                            avmProviderId: "9ed45e39-3f71-ee11-9937-000d3a37ca55",
                            propertyType: null,
                            clientProperties: [],
                            loanScenarios: [],
                            loans: [],
                            publicRecordRequests: [],
                            avmProvider: {
                                id: "9ed45e39-3f71-ee11-9937-000d3a37ca55",
                                name: "Quantarium"
                            }
                        },
                        clientPropertyAdjustments: [],
                        loans: [
                            {
                                loanInfo: {
                                    id: "8cb82466-717a-ee11-8925-6045bd0209a4",
                                    propertyId: "f786ec39-717a-ee11-8925-6045bd0209a4",
                                    appraisedValue: 632597.00,
                                    hoadues: null,
                                    floodInsurance: null,
                                    hazardInsuranceCompany: null,
                                    hazardInsurance: null,
                                    settlementCompany: null,
                                    totalMonthlyPayment: null,
                                    purchasePrice: null,
                                    purchaseDate: null,
                                    appraisalDate: null,
                                    totalLoanAmount: 726300.00,
                                    interestRate: 6.810,
                                    loanTerm: 360,
                                    monthlyPayment: 4739.77,
                                    loanPurposeTypeId: "5bae3400-9ad7-ea11-9b05-00155de9fd28",
                                    purposeRefinanceTypeId: null,
                                    refinanceTypeId: null,
                                    lienTypeId: "f3a23182-20ac-ea11-9b05-000d3a3287e5",
                                    amortizationTypeId: null,
                                    programId: null,
                                    armindex: null,
                                    armadjustmentCap: null,
                                    armfirstChangeMonths: null,
                                    armmargin: null,
                                    armlifeCap: null,
                                    armfirstAdjustmentCap: null,
                                    apr: null,
                                    firstPaymentDate: "2022-10-01T00:00:00",
                                    lastPaymentDate: "2052-10-01T00:00:00",
                                    monthlyMortgageInsurance: null,
                                    closingDate: "2022-08-21T07:00:00",
                                    hudescrowMonthlyPayment: null,
                                    loanTypeId: "d03831a8-83b6-ea11-9b05-000d3a3287e5",
                                    nmlsloanTypeId: null,
                                    upfrontMipPercentage: null,
                                    nmlsid: null,
                                    lenderNmlsid: null,
                                    loanNumber: null,
                                    lenderCaseNumber: null,
                                    subjectPropertyAddress: null,
                                    subjectPropertyCity: null,
                                    subjectPropertyState: null,
                                    subjectPropertyZip: null,
                                    propertyTypeId: null,
                                    yearBuilt: null,
                                    numberOfBedroom: null,
                                    numberOfBath: null,
                                    homeSize: null,
                                    lotSize: null,
                                    yearAcquired: null,
                                    parcelNumber: null,
                                    sellersAgentCompany: null,
                                    sellersAgentAddress: null,
                                    sellersAgentCity: null,
                                    sellersAgentState: null,
                                    sellersAgentZip: null,
                                    sellersAgentCompanyLicenseNumber: null,
                                    sellersAgentName: null,
                                    sellersAgentLicenseNumber: null,
                                    sellersAgentEmail: null,
                                    sellersAgentPhone: null,
                                    residenceTypeId: "50a33182-20ac-ea11-9b05-000d3a3287e5",
                                    externalId: "d1996e5e-717a-ee11-8925-6045bd0209a4",
                                    createdTimestamp: "2023-11-03T17:49:52.59",
                                    updatedTimestamp: "2023-11-03T18:26:10.723",
                                    lmcreditScore: null,
                                    respaApplicationDate: null,
                                    ltv: null,
                                    firstInterestChangeDate: null,
                                    indexTypeCode: null,
                                    totalMargin: null,
                                    indexValue: null,
                                    lifeFloor: null,
                                    lifeTimeCap: null,
                                    firstAdjustmentCap: null,
                                    periodicCap: null,
                                    amortTerm: null,
                                    interestAdjustPeriod: null,
                                    externalLoanSource: "Public Records",
                                    alreadyRefinanced: false,
                                    alreadySold: false,
                                    alreadyRefinancedAnotherLender: null,
                                    earlyPayoffDate: null,
                                    clientInterestRate: 6.250,
                                    clientPurchasePrice: 925000.00,
                                    clientEstimatedBalance: 723735.0,
                                    clientMonthlyMortgageInsurance: null,
                                    clientEstimatedBalanceUpdatedTimestamp: "2023-11-03T18:26:10.723",
                                    otherLoanBalance: null,
                                    encompassId: null,
                                    isActive: true,
                                    lastDataTraceLoanConfirmTimeStamp: null,
                                    lastDataTraceCheckupTimeStamp: null,
                                    lastPublicRecordConfirmDate: "2023-11-03T17:50:21.007",
                                    lender: "UBS BANK USA",
                                    isLoanRemoved: false,
                                    amortizationType: null,
                                    lienType: null,
                                    loanPurposeType: null,
                                    nmlsloanType: null,
                                    program: null,
                                    property: null,
                                    purposeRefinanceType: null,
                                    refinanceType: null,
                                    residenceType: null,
                                    clientLoans: [],
                                    loanAnalyses: [],
                                    loanApplications: [],
                                    opportunities: [],
                                    pricingRequests: []
                                },
                                loanAnalysis: {
                                    id: "8db82466-717a-ee11-8925-6045bd0209a4",
                                    loanId: "8cb82466-717a-ee11-8925-6045bd0209a4",
                                    ownerId: "b9b89048-6d31-ee11-a9bb-000d3a37c80a",
                                    creditScore: null,
                                    loanOrigination: null,
                                    closedDate: "2022-08-21T07:00:00",
                                    interestRate: 6.250,
                                    monthlyInterestRate: 0.005208333333,
                                    totalMortgageLoanAmount: 726300.00,
                                    appraisalValue: 632597.00,
                                    loanPurpose: "Other",
                                    loanTerm: 360,
                                    loanType: "CONV",
                                    progType: null,
                                    ownerOccupied: "YES",
                                    ltv: 0.000,
                                    ltvthreshold: null,
                                    analysisPaymentSavingThreshold: null,
                                    analysisConformingThreshold: null,
                                    analysisMipmtSavingThreshold: null,
                                    armfirstAdjustmentDate: null,
                                    monthlyPaymentMi: 0.00,
                                    monthsAgoClosed: 15,
                                    loanPayment: 4739.77,
                                    payment: 4471.954026507941,
                                    balanceNeededForLtv: null,
                                    totalInterest: 56356.67294103751,
                                    totalPrincipal: 10722.637456581462,
                                    estimatedBalance: 722981.5184753577,
                                    deltaToLtv: null,
                                    monthsToLtv: 0.0,
                                    monthForLtv: "2022-08-21T07:00:00",
                                    deltaToConforming: null,
                                    monthsToConforming: 0.0,
                                    monthForConforming: "2022-08-21T07:00:00",
                                    yearToDatePrincipal: 7944.460802864982,
                                    yearToDateInterest: 41247.03348872225,
                                    lastYearPrincipal: 2778.1766537164804,
                                    lastYearInterest: 15109.639452315274,
                                    remainingPrincipal: 722981.5184753577,
                                    remainingInterest: 832908.0009186384,
                                    estimatedLtv: 114.28785126634455,
                                    marketMonthlyPaymentMi: null,
                                    totalPaymentWithMi: 4471.954026507941,
                                    estimatedCashOutLimit: -50380.018475357734,
                                    estimatedHomeValue: 896802.00,
                                    estimatedLtvhomeValueBased: 80.6177415388634,
                                    marketMonthlyPaymentMifixed: null,
                                    marketMonthlyPaymentMiarm: null,
                                    notEligibleForOpportunity: false,
                                    combinedLoanBalance: 722981.5184753577,
                                    monthsSinceLastDataTraceCheckup: 15,
                                    loan: null,
                                    owner: null
                                },
                                loanPurposeType: {
                                    id: "5bae3400-9ad7-ea11-9b05-00155de9fd28",
                                    name: "Other",
                                    displayOrder: null,
                                    companyId: "74133991-9d90-ea11-86e9-000d3a328c22",
                                    loans: []
                                },
                                purposeRefinanceType: null,
                                refinanceType: null,
                                lienType: {
                                    id: "f3a23182-20ac-ea11-9b05-000d3a3287e5",
                                    name: "First Mortgage",
                                    displayOrder: 1,
                                    companyId: "74133991-9d90-ea11-86e9-000d3a328c22",
                                    loans: []
                                },
                                amortizationType: null,
                                program: null,
                                loanType: {
                                    id: "d03831a8-83b6-ea11-9b05-000d3a3287e5",
                                    name: "CONV",
                                    displayOrder: null,
                                    companyId: "74133991-9d90-ea11-86e9-000d3a328c22",
                                    pricingConfigs: []
                                },
                                nmlsloanType: null,
                                propertyType: null,
                                residenceType: {
                                    id: "50a33182-20ac-ea11-9b05-000d3a3287e5",
                                    name: "Primary",
                                    lgvcode: "YES",
                                    displayOrder: 1,
                                    companyId: "74133991-9d90-ea11-86e9-000d3a328c22",
                                    clientProperties: [],
                                    loanScenarios: [],
                                    loans: []
                                }
                            }
                        ],
                        associationType: "Owned",
                        propertyType: null,
                        loanScenarios: [],
                        isPrimaryProperty: true,
                        listingPrice: 1.00,
                        pricingStatus: null
                    },
                    {
                        propertyInfo: {
                            id: "78b9aa9b-717a-ee11-8925-6045bd0209a4",
                            address: "5631 RHODESIA RD",
                            city: "CARNELIAN BAY",
                            state: "CA",
                            zip: "96140",
                            propertyTypeId: "3aa33182-20ac-ea11-9b05-000d3a3287e5",
                            yearBuilt: 1973,
                            parcelNumber: null,
                            coreLogicPropertyId: null,
                            county: "PLACER",
                            ownerName: "PFEIFFER, CHRISTIAN N & JILL E",
                            avmestimatedValue: 986571.00,
                            avmlowValue: 868182.00,
                            avmhighValue: 1104959.00,
                            avmprocessedDate: "2023-10-25T00:00:00",
                            avmforecastStandardDeviation: 12.000,
                            apn: null,
                            landUse: null,
                            landUseCode: null,
                            censusTract: null,
                            absenteeOwner: null,
                            latitude: 39.229976,
                            longitude: -120.077682,
                            standardLandUse: null,
                            standardLandUseCode: null,
                            livingArea: 1472,
                            totalRooms: null,
                            bedrooms: 3,
                            fullBath: null,
                            halfBath: null,
                            totalBaths: 2.0,
                            pool: null,
                            numberOfStories: null,
                            lotArea: 12329,
                            effectiveYearBuilt: null,
                            airConditioning: null,
                            fireplace: 1,
                            parking: null,
                            propertyValuationId: "15672825",
                            propertyValuationIdSearchSuccessful: true,
                            lastPropertyValuationSearch: null,
                            clientEstimatedValue: null,
                            clientEstimatedValueDelta: null,
                            clientEstimatedValueUpdatedTimestamp: null,
                            clientEstimatedValueUpdatedBy: null,
                            marketValueHistoryUpdatedTimestamp: "2023-11-03T17:51:26.983",
                            createdTimestamp: "2023-11-03T17:51:26.663",
                            updatedTimestamp: null,
                            marketValueUpdatedTimestamp: "2023-11-03T17:51:27.117",
                            isMarketValueUpdatedByScheduler: false,
                            source: "Manual",
                            dataTracePropertyId: null,
                            qvmPropertyId: null,
                            qvmSearchTimestamp: "2023-11-03T17:51:26.663",
                            qvmSearchResultsCount: null,
                            sourceAddress: null,
                            sourceCity: null,
                            sourceState: null,
                            sourceZip: null,
                            sourceCounty: null,
                            lastPublicRecordCheckupDate: null,
                            basementArea: null,
                            zoning: "018",
                            neighborhoodName: "AGATE BAY VISTA",
                            schoolDistrict: "Tahoe-Truckee Unified School District",
                            elementarySchool: null,
                            middleSchool: null,
                            highSchool: null,
                            salePrice: 868000.00,
                            saleDate: "2021-07-27T00:00:00",
                            taxYear: 2022,
                            propertyTax: 10303.06,
                            assessedValue: 885360.00,
                            garage: null,
                            garageParkingSpaceCount: null,
                            avmProviderId: "9ed45e39-3f71-ee11-9937-000d3a37ca55",
                            propertyType: null,
                            clientProperties: [],
                            loanScenarios: [],
                            loans: [],
                            publicRecordRequests: [],
                            avmProvider: {
                                id: "9ed45e39-3f71-ee11-9937-000d3a37ca55",
                                name: "Quantarium"
                            }
                        },
                        clientPropertyAdjustments: [],
                        loans: [],
                        associationType: "Prospect",
                        propertyType: "SFR-Detached",
                        loanScenarios: [
                            {
                                id: "54a7cbb5-7e2d-4c9d-95d3-7580342a1b8d",
                                createdOn: "2023-11-03T17:52:48.653",
                                updatedOn: null,
                                purchasePrice: 950000.00,
                                downPayment: 190000.00,
                                loanAmount: 760000.00,
                                payDownPoints: false,
                                residenceType: "Secondary",
                                client: null,
                                property: null,
                                opportunities: null,
                                pricingRequests: null
                            }
                        ],
                        isPrimaryProperty: false,
                        listingPrice: 950000.00,
                        pricingStatus: "Products Selected"
                    }
                ],
                goals: [
                    {
                        id: "521f6cf9-5bd7-ea11-9b05-00155de9fd28",
                        description: "Buy a new home",
                        displayOrder: 3,
                        enabled: false
                    },
                    {
                        id: "531f6cf9-5bd7-ea11-9b05-00155de9fd28",
                        description: "Buy an investment property",
                        displayOrder: 6,
                        enabled: false
                    },
                    {
                        id: "541f6cf9-5bd7-ea11-9b05-00155de9fd28",
                        description: "Downsize my home",
                        displayOrder: 7,
                        enabled: false
                    },
                    {
                        id: "551f6cf9-5bd7-ea11-9b05-00155de9fd28",
                        description: "Lower my payment",
                        displayOrder: 2,
                        enabled: false
                    },
                    {
                        id: "561f6cf9-5bd7-ea11-9b05-00155de9fd28",
                        description: "Pay off my loan sooner",
                        displayOrder: 1,
                        enabled: false
                    },
                    {
                        id: "571f6cf9-5bd7-ea11-9b05-00155de9fd28",
                        description: "Rent my home and buy another",
                        displayOrder: 8,
                        enabled: false
                    },
                    {
                        id: "581f6cf9-5bd7-ea11-9b05-00155de9fd28",
                        description: "Sell my home",
                        displayOrder: 4,
                        enabled: false
                    },
                    {
                        id: "591f6cf9-5bd7-ea11-9b05-00155de9fd28",
                        description: "Use or manage my equity",
                        displayOrder: 5,
                        enabled: false
                    }
                ],
                activities: [
                    {
                        id: "9d6047dd-a07a-ee11-8925-6045bd0209a4",
                        clientId: "f686ec39-717a-ee11-8925-6045bd0209a4",
                        activityTypeId: "6cb99231-d176-40cd-bc51-83843a1ab81b",
                        activityTypeName: "Page Click",
                        activityTimestamp: "2023-11-03T23:29:44.717",
                        createdTimestamp: "2023-11-03T23:29:44.717",
                        notes: "Education"
                    },
                    {
                        id: "9c6047dd-a07a-ee11-8925-6045bd0209a4",
                        clientId: "f686ec39-717a-ee11-8925-6045bd0209a4",
                        activityTypeId: "beb73295-a8ca-ea11-8b03-000d3a3280f4",
                        activityTypeName: "Log in",
                        activityTimestamp: "2023-11-03T23:29:43.93",
                        createdTimestamp: "2023-11-03T23:29:43.93",
                        notes: null
                    }
                ]
            }
        );
    }
    //#endregion Client Data


    //#region opportunities
    mockOpportunities() : Observable<LgvModel.Opportunity[]> {
        return of([
            {
              "opportunityInfo": {
                "feeDetails": [
                  {
                    "amount": 0,
                    "description": "string",
                    "isOrigination": true,
                    "points": 0,
                    "type": "string"
                  }
                ],
                "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                "loanId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                "opportunityTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                "paymentSavingThreshold": 0,
                "paymentSavings": 0,
                "mipmtSavingThreshold": 0,
                "mipaymentSavings": 0,
                "ltvthreshold": 0,
                "estimatedLtv": 0,
                "conformingThreshold": 0,
                "estimatedBalance": 0,
                "matchedRate": 0,
                "matchedPrice": 0,
                "marketPayment": 0,
                "marketMonthlyPaymentMi": 0,
                "loanTermMonths": 0,
                "loanTypeName": "string",
                "productName": "string",
                "amortizationTypeName": "string",
                "loanAmount": 0,
                "armfixedTermMonths": 0,
                "updatedTimestamp": "2024-01-03T23:40:21.113Z",
                "estimatedCashOutLimit": 0,
                "matchedApr": 0,
                "pricingId": 0,
                "loanPurpose": "string",
                "createdTimeStamp": new Date("2024-01-03T23:40:21.113Z"),
                "productIndex": "string",
                "productCode": "string",
                "lockPeriod": 0,
                "priceStatus": "string",
                "loanScenarioId": null,
                "adjustedApr": 0,
                "adjustedFee": 0,
                "armmargin": 0,
                "armindexValue": 0,
                "armfirstCap": 0,
                "armperiodicCap": 0,
                "armlifetimeCap": 0,
                "armindexName": "string",
                "points": 0,
                "pointsCost": 0,
                "closingCost": 0,
                "client": {
                  "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "ownerId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "clientType": "string",
                  "username": "string",
                  "firstName": "string",
                  "lastName": "string",
                  "nickName": "string",
                  "gender": "string",
                  "email": "string",
                  "homePhone": "string",
                  "workPhone": "string",
                  "mobilePhone": "string",
                  "fax": "string",
                  "birthDate": "2024-01-03T23:40:21.113Z",
                  "totalIncome": 0,
                  "maritalStatus": "string",
                  "numberDependents": 0,
                  "dependentAges": "string",
                  "address1": "string",
                  "address2": "string",
                  "city": "string",
                  "state": "string",
                  "zipCode": "string",
                  "fico": 0,
                  "isSubscribed": true,
                  "serviceInterest": "string",
                  "isSilenced": true,
                  "isArchived": true,
                  "isDeleted": true,
                  "externalId": "string",
                  "createdTimestamp": "2024-01-03T23:40:21.113Z",
                  "updatedTimestamp": "2024-01-03T23:40:21.113Z",
                  "identityServiceId": "string",
                  "registeredDate": "2024-01-03T23:40:21.113Z",
                  "mailChimpStartDate": "2024-01-03T23:40:21.113Z",
                  "mailChimpEmail": "string",
                  "previousMailChimpStartDate": "2024-01-03T23:40:21.113Z",
                  "source": "string",
                  "lastEmailReceivedDate": "2024-01-03T23:40:21.113Z",
                  "firstTimeBuyer": true,
                  "totalDebtPayments": 0,
                  "owner": {
                    "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "username": "string",
                    "externalId": "string",
                    "firstName": "string",
                    "lastName": "string",
                    "jobTitle": "string",
                    "nmlsid": "string",
                    "licenseNumber": "string",
                    "userAccessId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "email": "string",
                    "address1": "string",
                    "address2": "string",
                    "city": "string",
                    "state": "string",
                    "zipCode": "string",
                    "phone": "string",
                    "mobilePhone": "string",
                    "fax": "string",
                    "organizationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "website": "string",
                    "costCenter": "string",
                    "profileImageUrl": "string",
                    "facebook": "string",
                    "twitter": "string",
                    "google": "string",
                    "linkedin": "string",
                    "youtube": "string",
                    "nickName": "string",
                    "disclaimer": "string",
                    "basisPoints": 0,
                    "minAmount": 0,
                    "maxAmount": 0,
                    "isDisabled": true,
                    "createdTimestamp": "2024-01-03T23:40:21.113Z",
                    "updatedTimestamp": "2024-01-03T23:40:21.113Z",
                    "identityServiceId": "string",
                    "analysisLtvthreshold": 0,
                    "analysisPaymentSavingThreshold": 0,
                    "analysisConformingThreshold": 0,
                    "analysisMipmtSavingThreshold": 0,
                    "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "yelp": "string",
                    "instagram": "string",
                    "zillow": "string",
                    "applicationUrl": "string",
                    "enrollmentDate": "2024-01-03T23:40:21.113Z",
                    "homebotOptIn": true,
                    "marginConf": 0,
                    "minConf": 0,
                    "maxConf": 0,
                    "marginHiBal": 0,
                    "minHiBal": 0,
                    "maxHiBal": 0,
                    "marginGovt": 0,
                    "minGovt": 0,
                    "maxGovt": 0,
                    "marginJumbo": 0,
                    "minJumbo": 0,
                    "maxJumbo": 0,
                    "isIlm": true,
                    "lastActivityEmailSentTimestamp": "2024-01-03T23:40:21.113Z",
                    "myHomeOptInDate": "2024-01-03T23:40:21.113Z",
                    "isLoinvitationSent": true,
                    "loinvitationSentDate": "2024-01-03T23:40:21.113Z",
                    "hidePricingForClientView": true,
                    "coBrandingAgentId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "source": "string",
                    "lastLoggedInTimestamp": "2024-01-03T23:40:21.113Z",
                    "obchannelIndex": 0,
                    "oboriginatorIndex": 0,
                    "isReadyForPricing": true,
                    "billingEntityId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "hasAcceptedTerms": true,
                    "acceptedTermsDateTime": "2024-01-03T23:40:21.113Z",
                    "hasSendEmailAsPermission": true,
                    "sendEmailAsPermissionDate": "2024-01-03T23:40:21.113Z",
                    "targetPrice": 0,
                    "maxFee": 0,
                    "coBrandingAgent": "string",
                    "company": {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "businessTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "name": "string",
                      "dbaname": "string",
                      "address1": "string",
                      "address2": "string",
                      "city": "string",
                      "state": "string",
                      "zipCode": "string",
                      "phone": "string",
                      "fax": "string",
                      "website": "string",
                      "nmlsid": "string",
                      "licenseNumber": "string",
                      "companyLogoUrl": "string",
                      "companyEmail": "string",
                      "disclaimer": "string",
                      "isDisabled": true,
                      "externalId": "string",
                      "createdTimestamp": "2024-01-03T23:40:21.114Z",
                      "updatedTimestamp": "2024-01-03T23:40:21.114Z",
                      "companyCode": "string",
                      "ftpfolder": "string",
                      "displayName": "string",
                      "businessType": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "name": "string",
                        "displayOrder": 0,
                        "companies": [
                          "string"
                        ]
                      },
                      "applicationCompanies": [
                        {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "applicationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "keyVaultUrl": "string",
                          "application": "string",
                          "company": "string"
                        }
                      ],
                      "bestPricings": [
                        {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "desiredAmortizationType": "string",
                          "desiredLoanTermMonths": "string",
                          "desiredLoanType": "string",
                          "desiredLoanPurpose": "string",
                          "ltv": 0,
                          "loanAmount": 0,
                          "propertyValuationAmount": 0,
                          "purchasePriceAmount": 0,
                          "productName": "string",
                          "productIndex": "string",
                          "productCode": "string",
                          "amortizationTermMonths": 0,
                          "amortizationTypeName": "string",
                          "armabsoluteCap": 0,
                          "armfirstCap": 0,
                          "armfixedTermMonths": 0,
                          "armindexName": "string",
                          "armperiodicCap": 0,
                          "armrelativeCap": 0,
                          "fhaupfrontPremiumAmount": 0,
                          "investorEntityIndex": 0,
                          "investorEntityName": "string",
                          "loanTermMonths": 0,
                          "loanTypeName": "string",
                          "lockPeriod": 0,
                          "margin": 0,
                          "miannualPremiumAmount": 0,
                          "mimonthlyPremiumAmount": 0,
                          "mimonthlyPremiumPercent": 0,
                          "mirequiredForLoan": "string",
                          "originationApr": 0,
                          "originationPandI": 0,
                          "originationTotalClosingCost": 0,
                          "price": 0,
                          "rate": 0,
                          "totalMarginAdjustment": 0,
                          "totalPriceAdjustment": 0,
                          "totalRateAdjustment": 0,
                          "totalSrpadjustment": 0,
                          "updatedTimestamp": "2024-01-03T23:40:21.114Z",
                          "company": "string"
                        }
                      ],
                      "loanApplications": [
                        "string"
                      ],
                      "organizations": [
                        {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "name": "string",
                          "address1": "string",
                          "address2": "string",
                          "city": "string",
                          "state": "string",
                          "zipCode": "string",
                          "phone": "string",
                          "fax": "string",
                          "nmlsid": "string",
                          "licenseNumber": "string",
                          "organizationLogoUrl": "string",
                          "organizationEmail": "string",
                          "disclaimer": "string",
                          "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "isDisabled": true,
                          "externalId": "string",
                          "createdTimestamp": "2024-01-03T23:40:21.114Z",
                          "updatedTimestamp": "2024-01-03T23:40:21.114Z",
                          "coBrandingAgentId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "coBrandingAgent": "string",
                          "company": "string",
                          "users": [
                            "string"
                          ]
                        }
                      ],
                      "pageAccesses": [
                        {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "pageId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "rolename": "string",
                          "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "company": "string",
                          "page": {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "key": "string",
                            "pageCategoryId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "title": "string",
                            "path": "string",
                            "sortOrder": 0,
                            "isDeleted": true,
                            "screenLoadMethodId": 0,
                            "pageCategory": {
                              "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                              "key": "string",
                              "title": "string",
                              "sortOrder": 0,
                              "faIcon": "string",
                              "pages": [
                                "string"
                              ]
                            },
                            "screenLoadMethod": {
                              "id": 0,
                              "description": "string",
                              "pages": [
                                "string"
                              ]
                            },
                            "pageAccesses": [
                              "string"
                            ]
                          }
                        }
                      ],
                      "pricingConfigs": [
                        {
                          "id": 0,
                          "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "loanTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "defaultRequestPayload": "string",
                          "company": "string",
                          "loanType": {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "name": "string",
                            "displayOrder": 0,
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "pricingConfigs": [
                              "string"
                            ]
                          }
                        }
                      ],
                      "pricings": [
                        {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "desiredAmortizationType": "string",
                          "desiredLoanTermMonths": "string",
                          "desiredLoanType": "string",
                          "desiredLoanPurpose": "string",
                          "ltv": 0,
                          "loanAmount": 0,
                          "propertyValuationAmount": 0,
                          "purchasePriceAmount": 0,
                          "productName": "string",
                          "productIndex": "string",
                          "productCode": "string",
                          "amortizationTermMonths": 0,
                          "amortizationTypeName": "string",
                          "armabsoluteCap": 0,
                          "armfirstCap": 0,
                          "armfixedTermMonths": 0,
                          "armindexName": "string",
                          "armperiodicCap": 0,
                          "armrelativeCap": 0,
                          "fhaupfrontPremiumAmount": 0,
                          "investorEntityIndex": 0,
                          "investorEntityName": "string",
                          "loanTermMonths": 0,
                          "loanTypeName": "string",
                          "lockPeriod": 0,
                          "margin": 0,
                          "miannualPremiumAmount": 0,
                          "mimonthlyPremiumAmount": 0,
                          "mimonthlyPremiumPercent": 0,
                          "mirequiredForLoan": "string",
                          "originationApr": 0,
                          "originationPandI": 0,
                          "originationTotalClosingCost": 0,
                          "price": 0,
                          "rate": 0,
                          "totalMarginAdjustment": 0,
                          "totalPriceAdjustment": 0,
                          "totalRateAdjustment": 0,
                          "totalSrpadjustment": 0,
                          "updatedTimestamp": "2024-01-03T23:40:21.114Z",
                          "discount": 0,
                          "rebate": 0,
                          "totalCredit": 0,
                          "company": "string"
                        }
                      ],
                      "sendGridTemplates": [
                        {
                          "id": 0,
                          "companyName": "string",
                          "templateName": "string",
                          "templateId": "string",
                          "apikey": "string",
                          "isWelcome": true,
                          "isActive": true,
                          "unsubscribeGroupId": 0,
                          "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "company": "string"
                        }
                      ],
                      "userFileUploads": [
                        {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "importTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "statusId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "fileUploadDateTime": "2024-01-03T23:40:21.114Z",
                          "fileUploadName": "string",
                          "result": "string",
                          "company": "string",
                          "importType": {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "name": "string",
                            "userFileUploads": [
                              "string"
                            ]
                          },
                          "status": {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "name": "string",
                            "userFileUploads": [
                              "string"
                            ]
                          },
                          "user": "string"
                        }
                      ],
                      "users": [
                        "string"
                      ],
                      "lenderPartnerCompanyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "companySocialMedia": [
                        {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "socialMediaTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "link": "string",
                          "createdDateTime": "2024-01-03T23:40:21.114Z",
                          "updatedDateTime": "2024-01-03T23:40:21.114Z",
                          "company": "string"
                        }
                      ],
                      "userInvites": [
                        {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "senderUserId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "assignedCompanyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "firstName": "string",
                          "lastName": "string",
                          "email": "string",
                          "inviteDateTime": "2024-01-03T23:40:21.114Z",
                          "hasAcceptedTerms": true,
                          "acceptedTermsDateTime": "2024-01-03T23:40:21.114Z",
                          "assignedCompany": "string",
                          "senderUser": "string"
                        }
                      ]
                    },
                    "organization": {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "name": "string",
                      "address1": "string",
                      "address2": "string",
                      "city": "string",
                      "state": "string",
                      "zipCode": "string",
                      "phone": "string",
                      "fax": "string",
                      "nmlsid": "string",
                      "licenseNumber": "string",
                      "organizationLogoUrl": "string",
                      "organizationEmail": "string",
                      "disclaimer": "string",
                      "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "isDisabled": true,
                      "externalId": "string",
                      "createdTimestamp": "2024-01-03T23:40:21.114Z",
                      "updatedTimestamp": "2024-01-03T23:40:21.114Z",
                      "coBrandingAgentId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "coBrandingAgent": "string",
                      "company": "string",
                      "users": [
                        "string"
                      ]
                    },
                    "agentClientDisabledContentLists": [
                      {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "contentId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "content": {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "description": "string",
                          "displayOrder": 0,
                          "createdTimestamp": "2024-01-03T23:40:21.114Z",
                          "updatedTimestamp": "2024-01-03T23:40:21.114Z",
                          "key": "string",
                          "title": "string",
                          "isDeleted": true,
                          "contentTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "contentType": {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "name": "string",
                            "agentClientContents": [
                              "string"
                            ]
                          },
                          "agentClientDisabledContentLists": [
                            "string"
                          ]
                        },
                        "user": "string"
                      }
                    ],
                    "agentClientDisabledPageLists": [
                      {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "pageId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "page": {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "description": "string",
                          "displayOrder": 0,
                          "createdTimestamp": "2024-01-03T23:40:21.114Z",
                          "updatedTimestamp": "2024-01-03T23:40:21.114Z",
                          "key": "string",
                          "title": "string",
                          "isDeleted": true,
                          "isNavigationPage": true,
                          "agentClientDisabledPageLists": [
                            "string"
                          ]
                        },
                        "user": "string"
                      }
                    ],
                    "applicationUsers": [
                      {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "applicationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "indexName": "string",
                        "indexValue": "string",
                        "application": "string",
                        "user": "string"
                      }
                    ],
                    "assistantBindingAgentUsers": [
                      {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "assistantUserId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "agentUserId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "alertWhenEmailSent": true,
                        "agentUser": "string",
                        "assistantUser": "string"
                      }
                    ],
                    "assistantBindingAssistantUsers": [
                      {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "assistantUserId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "agentUserId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "alertWhenEmailSent": true,
                        "agentUser": "string",
                        "assistantUser": "string"
                      }
                    ],
                    "clients": [
                      "string"
                    ],
                    "inverseCoBrandingAgent": [
                      "string"
                    ],
                    "loanAnalyses": [
                      {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "loanId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "ownerId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "creditScore": 0,
                        "loanOrigination": "2024-01-03T23:40:21.114Z",
                        "closedDate": "2024-01-03T23:40:21.114Z",
                        "interestRate": 0,
                        "monthlyInterestRate": 0,
                        "totalMortgageLoanAmount": 0,
                        "appraisalValue": 0,
                        "loanPurpose": "string",
                        "loanTerm": 0,
                        "loanType": "string",
                        "progType": "string",
                        "ownerOccupied": "str",
                        "ltv": 0,
                        "ltvthreshold": 0,
                        "analysisPaymentSavingThreshold": 0,
                        "analysisConformingThreshold": 0,
                        "analysisMipmtSavingThreshold": 0,
                        "armfirstAdjustmentDate": "2024-01-03T23:40:21.114Z",
                        "monthlyPaymentMi": 0,
                        "monthsAgoClosed": 0,
                        "loanPayment": 0,
                        "payment": 0,
                        "balanceNeededForLtv": 0,
                        "totalInterest": 0,
                        "totalPrincipal": 0,
                        "estimatedBalance": 0,
                        "deltaToLtv": 0,
                        "monthsToLtv": 0,
                        "monthForLtv": "2024-01-03T23:40:21.114Z",
                        "deltaToConforming": 0,
                        "monthsToConforming": 0,
                        "monthForConforming": "2024-01-03T23:40:21.114Z",
                        "yearToDatePrincipal": 0,
                        "yearToDateInterest": 0,
                        "lastYearPrincipal": 0,
                        "lastYearInterest": 0,
                        "remainingPrincipal": 0,
                        "remainingInterest": 0,
                        "estimatedLtv": 0,
                        "marketMonthlyPaymentMi": 0,
                        "totalPaymentWithMi": 0,
                        "estimatedCashOutLimit": 0,
                        "estimatedHomeValue": 0,
                        "estimatedLtvhomeValueBased": 0,
                        "marketMonthlyPaymentMifixed": 0,
                        "marketMonthlyPaymentMiarm": 0,
                        "notEligibleForOpportunity": true,
                        "combinedLoanBalance": 0,
                        "monthsSinceLastDataTraceCheckup": 0,
                        "loan": "string",
                        "owner": "string"
                      }
                    ],
                    "organizations": [
                      {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "name": "string",
                        "address1": "string",
                        "address2": "string",
                        "city": "string",
                        "state": "string",
                        "zipCode": "string",
                        "phone": "string",
                        "fax": "string",
                        "nmlsid": "string",
                        "licenseNumber": "string",
                        "organizationLogoUrl": "string",
                        "organizationEmail": "string",
                        "disclaimer": "string",
                        "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "isDisabled": true,
                        "externalId": "string",
                        "createdTimestamp": "2024-01-03T23:40:21.114Z",
                        "updatedTimestamp": "2024-01-03T23:40:21.114Z",
                        "coBrandingAgentId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "coBrandingAgent": "string",
                        "company": "string",
                        "users": [
                          "string"
                        ]
                      }
                    ],
                    "userFileUploads": [
                      {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "importTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "statusId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "fileUploadDateTime": "2024-01-03T23:40:21.114Z",
                        "fileUploadName": "string",
                        "result": "string",
                        "company": "string",
                        "importType": {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "name": "string",
                          "userFileUploads": [
                            "string"
                          ]
                        },
                        "status": {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "name": "string",
                          "userFileUploads": [
                            "string"
                          ]
                        },
                        "user": "string"
                      }
                    ],
                    "userRoleLists": [
                      {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "roleId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "dateTimeCreated": "2024-01-03T23:40:21.114Z",
                        "role": {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "code": "string",
                          "displayName": "string",
                          "description": "string",
                          "createdTimestamp": "2024-01-03T23:40:21.114Z",
                          "updatedTimestamp": "2024-01-03T23:40:21.114Z",
                          "userRoleLists": [
                            "string"
                          ]
                        },
                        "user": "string"
                      }
                    ],
                    "userSettings": [
                      {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "disableGettingStarted": true,
                        "analysisLtvthreshold": 0,
                        "analysisPaymentSavingThreshold": 0,
                        "analysisConformingThreshold": 0,
                        "analysisMipmtSavingThreshold": 0,
                        "alertWhenCampaignEmailSent": true,
                        "automaticBindingUserId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "currentBindingUserId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "currentBindingSetTime": "2024-01-03T23:40:21.114Z",
                        "startUpScreenKey": "string",
                        "agentAnnualVolumeGoal": 0,
                        "agentGoalDisplayMonths": 0,
                        "agentMonthlyVolume": 0,
                        "agentAnnualVolume": 0,
                        "totalVolumeLocked": 0,
                        "totalUnitsLocked": 0,
                        "monthlyPctGoalAchieved": 0,
                        "annualPctGoalAchieved": 0,
                        "totalUnits": 0,
                        "volumeRank": 0,
                        "branchVolumeRank": 0,
                        "firstHalfYearUnits": 0,
                        "secondHalfYearUnits": 0,
                        "firstHalfYearVolume": 0,
                        "secondHalfYearVolume": 0,
                        "qualifiedVolumeRank": 0,
                        "qualifiedUnitRank": 0,
                        "volumeForIncentiveProdStats": 0,
                        "unitsForIncentiveProdStats": 0,
                        "user": "string"
                      }
                    ],
                    "userSocialMedia": [
                      {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "socialMediaTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "link": "string",
                        "createdDateTime": "2024-01-03T23:40:21.114Z",
                        "updatedDateTime": "2024-01-03T23:40:21.114Z",
                        "user": "string"
                      }
                    ],
                    "billingEntity": {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "firstName": "string",
                      "lastName": "string",
                      "email": "string",
                      "billingAppIndex": "string",
                      "status": "string",
                      "billingStartDate": "2024-01-03T23:40:21.114Z",
                      "createdTimestamp": "2024-01-03T23:40:21.114Z",
                      "updatedTimestamp": "2024-01-03T23:40:21.114Z",
                      "users": [
                        "string"
                      ]
                    },
                    "userInvites": [
                      {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "senderUserId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "assignedCompanyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "firstName": "string",
                        "lastName": "string",
                        "email": "string",
                        "inviteDateTime": "2024-01-03T23:40:21.114Z",
                        "hasAcceptedTerms": true,
                        "acceptedTermsDateTime": "2024-01-03T23:40:21.114Z",
                        "assignedCompany": "string",
                        "senderUser": "string"
                      }
                    ]
                  },
                  "activities": [
                    {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "activityTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "activityTimestamp": "2024-01-03T23:40:21.114Z",
                      "createdTimestamp": "2024-01-03T23:40:21.114Z",
                      "notes": "string",
                      "appInstanceId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "activityType": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "name": "string",
                        "displayOrder": 0,
                        "isReleventActivity": true,
                        "isEmailActivity": true,
                        "activities": [
                          "string"
                        ]
                      },
                      "client": "string"
                    }
                  ],
                  "clientGoals": [
                    {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "goalId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "optionEntered": "string",
                      "createdTimestamp": "2024-01-03T23:40:21.114Z",
                      "client": "string",
                      "goal": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "description": "string",
                        "displayOrder": 0,
                        "clientGoals": [
                          "string"
                        ]
                      }
                    }
                  ],
                  "clientNonHomeLoans": [
                    {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "nonHomeLoanId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "client": "string",
                      "nonHomeLoan": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "balance": 0,
                        "rate": 0,
                        "monthlyPayment": 0,
                        "nonHomeLoanType": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "createdTimestamp": "2024-01-03T23:40:21.114Z",
                        "updatedTimestamp": "2024-01-03T23:40:21.114Z",
                        "client": "string",
                        "nonHomeLoanTypeNavigation": {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "name": "string",
                          "nonHomeLoans": [
                            "string"
                          ]
                        },
                        "clientNonHomeLoans": [
                          "string"
                        ]
                      }
                    }
                  ],
                  "clientProperties": [
                    {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "propertyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "propertyAssociationTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "residenceTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "pricingStatusId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "listingPrice": 0,
                      "createdTimeStamp": "2024-01-03T23:40:21.114Z",
                      "updatedTimeStamp": "2024-01-03T23:40:21.114Z",
                      "primaryProperty": true,
                      "readyForPricingEmailSent": true,
                      "client": "string",
                      "pricingStatus": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "name": "string",
                        "displayOrder": 0,
                        "clientProperties": [
                          "string"
                        ]
                      },
                      "property": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "address": "string",
                        "city": "string",
                        "state": "string",
                        "zip": "string",
                        "propertyTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "yearBuilt": 0,
                        "parcelNumber": "string",
                        "coreLogicPropertyId": "string",
                        "county": "string",
                        "ownerName": "string",
                        "avmestimatedValue": 0,
                        "avmlowValue": 0,
                        "avmhighValue": 0,
                        "avmprocessedDate": "2024-01-03T23:40:21.114Z",
                        "avmforecastStandardDeviation": 0,
                        "apn": "string",
                        "landUse": "string",
                        "landUseCode": "string",
                        "censusTract": "string",
                        "absenteeOwner": true,
                        "latitude": 0,
                        "longitude": 0,
                        "standardLandUse": "string",
                        "standardLandUseCode": "string",
                        "livingArea": 0,
                        "totalRooms": 0,
                        "bedrooms": 0,
                        "fullBath": 0,
                        "halfBath": 0,
                        "totalBaths": 0,
                        "pool": true,
                        "numberOfStories": 0,
                        "lotArea": 0,
                        "effectiveYearBuilt": 0,
                        "airConditioning": true,
                        "fireplace": 0,
                        "parking": 0,
                        "propertyValuationId": "string",
                        "propertyValuationIdSearchSuccessful": true,
                        "lastPropertyValuationSearch": "2024-01-03T23:40:21.114Z",
                        "clientEstimatedValue": 0,
                        "clientEstimatedValueDelta": 0,
                        "clientEstimatedValueUpdatedTimestamp": "2024-01-03T23:40:21.114Z",
                        "clientEstimatedValueUpdatedBy": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "marketValueHistoryUpdatedTimestamp": "2024-01-03T23:40:21.114Z",
                        "createdTimestamp": "2024-01-03T23:40:21.114Z",
                        "updatedTimestamp": "2024-01-03T23:40:21.114Z",
                        "marketValueUpdatedTimestamp": "2024-01-03T23:40:21.114Z",
                        "isMarketValueUpdatedByScheduler": true,
                        "source": "string",
                        "dataTracePropertyId": 0,
                        "qvmPropertyId": 0,
                        "qvmSearchTimestamp": "2024-01-03T23:40:21.114Z",
                        "qvmSearchResultsCount": 0,
                        "sourceAddress": "string",
                        "sourceCity": "string",
                        "sourceState": "string",
                        "sourceZip": "string",
                        "sourceCounty": "string",
                        "lastPublicRecordCheckupDate": "2024-01-03T23:40:21.114Z",
                        "basementArea": 0,
                        "zoning": "string",
                        "neighborhoodName": "string",
                        "schoolDistrict": "string",
                        "elementarySchool": "string",
                        "middleSchool": "string",
                        "highSchool": "string",
                        "salePrice": 0,
                        "saleDate": "2024-01-03T23:40:21.114Z",
                        "taxYear": 0,
                        "propertyTax": 0,
                        "assessedValue": 0,
                        "garage": "string",
                        "garageParkingSpaceCount": 0,
                        "avmProviderId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "propertyType": {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "name": "string",
                          "displayOrder": 0,
                          "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "properties": [
                            "string"
                          ]
                        },
                        "clientProperties": [
                          "string"
                        ],
                        "loanScenarios": [
                          "string"
                        ],
                        "loans": [
                          "string"
                        ],
                        "publicRecordRequests": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "publicRecordProviderId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "hdpropertyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "publicRecordProviderRequestId": "string",
                            "requestorId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "requestorType": "string",
                            "requestStatus": "string",
                            "createdTimestamp": "2024-01-03T23:40:21.114Z",
                            "failureMessage": "string",
                            "hdproperty": "string",
                            "publicRecordProvider": {
                              "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                              "name": "string",
                              "publicRecordRequests": [
                                "string"
                              ]
                            }
                          }
                        ],
                        "avmProvider": {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "name": "string"
                        }
                      },
                      "propertyAssociationType": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "name": "string",
                        "createdTimeStamp": "2024-01-03T23:40:21.114Z",
                        "updatedTimeStamp": "2024-01-03T23:40:21.114Z",
                        "clientProperties": [
                          "string"
                        ]
                      },
                      "residenceType": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "name": "string",
                        "lgvcode": "string",
                        "displayOrder": 0,
                        "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "clientProperties": [
                          "string"
                        ],
                        "loanScenarios": [
                          "string"
                        ],
                        "loans": [
                          "string"
                        ]
                      },
                      "clientPropertyAdjustments": [
                        {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "adjustmentValue": 0,
                          "clientPropertyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "adjustmentTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "avmAdjustmentReasonId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "modifiedBy": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "modifiedByType": "string",
                          "createdTimestamp": "2024-01-03T23:40:21.114Z",
                          "updatedTimestamp": "2024-01-03T23:40:21.114Z",
                          "adjustmentType": {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "name": "string",
                            "clientPropertyAdjustments": [
                              "string"
                            ]
                          },
                          "clientProperty": "string",
                          "avmAdjustmentReason": {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "name": "string"
                          }
                        }
                      ]
                    }
                  ],
                  "loanApplications": [
                    {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "loanId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "externalId": "string",
                      "createdOn": "2024-01-03T23:40:21.114Z",
                      "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "applicationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "application": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "name": "string",
                        "type": "string",
                        "applicationCompanies": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "applicationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "keyVaultUrl": "string",
                            "application": "string",
                            "company": "string"
                          }
                        ],
                        "applicationUsers": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "applicationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "indexName": "string",
                            "indexValue": "string",
                            "application": "string",
                            "user": "string"
                          }
                        ],
                        "loanApplications": [
                          "string"
                        ]
                      },
                      "client": "string",
                      "company": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "businessTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "name": "string",
                        "dbaname": "string",
                        "address1": "string",
                        "address2": "string",
                        "city": "string",
                        "state": "string",
                        "zipCode": "string",
                        "phone": "string",
                        "fax": "string",
                        "website": "string",
                        "nmlsid": "string",
                        "licenseNumber": "string",
                        "companyLogoUrl": "string",
                        "companyEmail": "string",
                        "disclaimer": "string",
                        "isDisabled": true,
                        "externalId": "string",
                        "createdTimestamp": "2024-01-03T23:40:21.114Z",
                        "updatedTimestamp": "2024-01-03T23:40:21.114Z",
                        "companyCode": "string",
                        "ftpfolder": "string",
                        "displayName": "string",
                        "businessType": {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "name": "string",
                          "displayOrder": 0,
                          "companies": [
                            "string"
                          ]
                        },
                        "applicationCompanies": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "applicationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "keyVaultUrl": "string",
                            "application": "string",
                            "company": "string"
                          }
                        ],
                        "bestPricings": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "desiredAmortizationType": "string",
                            "desiredLoanTermMonths": "string",
                            "desiredLoanType": "string",
                            "desiredLoanPurpose": "string",
                            "ltv": 0,
                            "loanAmount": 0,
                            "propertyValuationAmount": 0,
                            "purchasePriceAmount": 0,
                            "productName": "string",
                            "productIndex": "string",
                            "productCode": "string",
                            "amortizationTermMonths": 0,
                            "amortizationTypeName": "string",
                            "armabsoluteCap": 0,
                            "armfirstCap": 0,
                            "armfixedTermMonths": 0,
                            "armindexName": "string",
                            "armperiodicCap": 0,
                            "armrelativeCap": 0,
                            "fhaupfrontPremiumAmount": 0,
                            "investorEntityIndex": 0,
                            "investorEntityName": "string",
                            "loanTermMonths": 0,
                            "loanTypeName": "string",
                            "lockPeriod": 0,
                            "margin": 0,
                            "miannualPremiumAmount": 0,
                            "mimonthlyPremiumAmount": 0,
                            "mimonthlyPremiumPercent": 0,
                            "mirequiredForLoan": "string",
                            "originationApr": 0,
                            "originationPandI": 0,
                            "originationTotalClosingCost": 0,
                            "price": 0,
                            "rate": 0,
                            "totalMarginAdjustment": 0,
                            "totalPriceAdjustment": 0,
                            "totalRateAdjustment": 0,
                            "totalSrpadjustment": 0,
                            "updatedTimestamp": "2024-01-03T23:40:21.114Z",
                            "company": "string"
                          }
                        ],
                        "loanApplications": [
                          "string"
                        ],
                        "organizations": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "name": "string",
                            "address1": "string",
                            "address2": "string",
                            "city": "string",
                            "state": "string",
                            "zipCode": "string",
                            "phone": "string",
                            "fax": "string",
                            "nmlsid": "string",
                            "licenseNumber": "string",
                            "organizationLogoUrl": "string",
                            "organizationEmail": "string",
                            "disclaimer": "string",
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "isDisabled": true,
                            "externalId": "string",
                            "createdTimestamp": "2024-01-03T23:40:21.114Z",
                            "updatedTimestamp": "2024-01-03T23:40:21.114Z",
                            "coBrandingAgentId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "coBrandingAgent": "string",
                            "company": "string",
                            "users": [
                              "string"
                            ]
                          }
                        ],
                        "pageAccesses": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "pageId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "rolename": "string",
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "company": "string",
                            "page": {
                              "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                              "key": "string",
                              "pageCategoryId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                              "title": "string",
                              "path": "string",
                              "sortOrder": 0,
                              "isDeleted": true,
                              "screenLoadMethodId": 0,
                              "pageCategory": {
                                "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                                "key": "string",
                                "title": "string",
                                "sortOrder": 0,
                                "faIcon": "string",
                                "pages": [
                                  "string"
                                ]
                              },
                              "screenLoadMethod": {
                                "id": 0,
                                "description": "string",
                                "pages": [
                                  "string"
                                ]
                              },
                              "pageAccesses": [
                                "string"
                              ]
                            }
                          }
                        ],
                        "pricingConfigs": [
                          {
                            "id": 0,
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "loanTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "defaultRequestPayload": "string",
                            "company": "string",
                            "loanType": {
                              "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                              "name": "string",
                              "displayOrder": 0,
                              "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                              "pricingConfigs": [
                                "string"
                              ]
                            }
                          }
                        ],
                        "pricings": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "desiredAmortizationType": "string",
                            "desiredLoanTermMonths": "string",
                            "desiredLoanType": "string",
                            "desiredLoanPurpose": "string",
                            "ltv": 0,
                            "loanAmount": 0,
                            "propertyValuationAmount": 0,
                            "purchasePriceAmount": 0,
                            "productName": "string",
                            "productIndex": "string",
                            "productCode": "string",
                            "amortizationTermMonths": 0,
                            "amortizationTypeName": "string",
                            "armabsoluteCap": 0,
                            "armfirstCap": 0,
                            "armfixedTermMonths": 0,
                            "armindexName": "string",
                            "armperiodicCap": 0,
                            "armrelativeCap": 0,
                            "fhaupfrontPremiumAmount": 0,
                            "investorEntityIndex": 0,
                            "investorEntityName": "string",
                            "loanTermMonths": 0,
                            "loanTypeName": "string",
                            "lockPeriod": 0,
                            "margin": 0,
                            "miannualPremiumAmount": 0,
                            "mimonthlyPremiumAmount": 0,
                            "mimonthlyPremiumPercent": 0,
                            "mirequiredForLoan": "string",
                            "originationApr": 0,
                            "originationPandI": 0,
                            "originationTotalClosingCost": 0,
                            "price": 0,
                            "rate": 0,
                            "totalMarginAdjustment": 0,
                            "totalPriceAdjustment": 0,
                            "totalRateAdjustment": 0,
                            "totalSrpadjustment": 0,
                            "updatedTimestamp": "2024-01-03T23:40:21.115Z",
                            "discount": 0,
                            "rebate": 0,
                            "totalCredit": 0,
                            "company": "string"
                          }
                        ],
                        "sendGridTemplates": [
                          {
                            "id": 0,
                            "companyName": "string",
                            "templateName": "string",
                            "templateId": "string",
                            "apikey": "string",
                            "isWelcome": true,
                            "isActive": true,
                            "unsubscribeGroupId": 0,
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "company": "string"
                          }
                        ],
                        "userFileUploads": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "importTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "statusId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "fileUploadDateTime": "2024-01-03T23:40:21.115Z",
                            "fileUploadName": "string",
                            "result": "string",
                            "company": "string",
                            "importType": {
                              "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                              "name": "string",
                              "userFileUploads": [
                                "string"
                              ]
                            },
                            "status": {
                              "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                              "name": "string",
                              "userFileUploads": [
                                "string"
                              ]
                            },
                            "user": "string"
                          }
                        ],
                        "users": [
                          "string"
                        ],
                        "lenderPartnerCompanyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "companySocialMedia": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "socialMediaTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "link": "string",
                            "createdDateTime": "2024-01-03T23:40:21.115Z",
                            "updatedDateTime": "2024-01-03T23:40:21.115Z",
                            "company": "string"
                          }
                        ],
                        "userInvites": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "senderUserId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "assignedCompanyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "firstName": "string",
                            "lastName": "string",
                            "email": "string",
                            "inviteDateTime": "2024-01-03T23:40:21.115Z",
                            "hasAcceptedTerms": true,
                            "acceptedTermsDateTime": "2024-01-03T23:40:21.115Z",
                            "assignedCompany": "string",
                            "senderUser": "string"
                          }
                        ]
                      },
                      "loan": "string"
                    }
                  ],
                  "loanScenarios": [
                    {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "purchasePrice": 0,
                      "downPayment": 0,
                      "payDownPoints": true,
                      "createdOn": "2024-01-03T23:40:21.115Z",
                      "updatedOn": "2024-01-03T23:40:21.115Z",
                      "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "residenceTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "propertyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "loanAmount": 0,
                      "client": "string",
                      "property": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "address": "string",
                        "city": "string",
                        "state": "string",
                        "zip": "string",
                        "propertyTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "yearBuilt": 0,
                        "parcelNumber": "string",
                        "coreLogicPropertyId": "string",
                        "county": "string",
                        "ownerName": "string",
                        "avmestimatedValue": 0,
                        "avmlowValue": 0,
                        "avmhighValue": 0,
                        "avmprocessedDate": "2024-01-03T23:40:21.115Z",
                        "avmforecastStandardDeviation": 0,
                        "apn": "string",
                        "landUse": "string",
                        "landUseCode": "string",
                        "censusTract": "string",
                        "absenteeOwner": true,
                        "latitude": 0,
                        "longitude": 0,
                        "standardLandUse": "string",
                        "standardLandUseCode": "string",
                        "livingArea": 0,
                        "totalRooms": 0,
                        "bedrooms": 0,
                        "fullBath": 0,
                        "halfBath": 0,
                        "totalBaths": 0,
                        "pool": true,
                        "numberOfStories": 0,
                        "lotArea": 0,
                        "effectiveYearBuilt": 0,
                        "airConditioning": true,
                        "fireplace": 0,
                        "parking": 0,
                        "propertyValuationId": "string",
                        "propertyValuationIdSearchSuccessful": true,
                        "lastPropertyValuationSearch": "2024-01-03T23:40:21.115Z",
                        "clientEstimatedValue": 0,
                        "clientEstimatedValueDelta": 0,
                        "clientEstimatedValueUpdatedTimestamp": "2024-01-03T23:40:21.115Z",
                        "clientEstimatedValueUpdatedBy": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "marketValueHistoryUpdatedTimestamp": "2024-01-03T23:40:21.115Z",
                        "createdTimestamp": "2024-01-03T23:40:21.115Z",
                        "updatedTimestamp": "2024-01-03T23:40:21.115Z",
                        "marketValueUpdatedTimestamp": "2024-01-03T23:40:21.115Z",
                        "isMarketValueUpdatedByScheduler": true,
                        "source": "string",
                        "dataTracePropertyId": 0,
                        "qvmPropertyId": 0,
                        "qvmSearchTimestamp": "2024-01-03T23:40:21.115Z",
                        "qvmSearchResultsCount": 0,
                        "sourceAddress": "string",
                        "sourceCity": "string",
                        "sourceState": "string",
                        "sourceZip": "string",
                        "sourceCounty": "string",
                        "lastPublicRecordCheckupDate": "2024-01-03T23:40:21.115Z",
                        "basementArea": 0,
                        "zoning": "string",
                        "neighborhoodName": "string",
                        "schoolDistrict": "string",
                        "elementarySchool": "string",
                        "middleSchool": "string",
                        "highSchool": "string",
                        "salePrice": 0,
                        "saleDate": "2024-01-03T23:40:21.115Z",
                        "taxYear": 0,
                        "propertyTax": 0,
                        "assessedValue": 0,
                        "garage": "string",
                        "garageParkingSpaceCount": 0,
                        "avmProviderId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "propertyType": {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "name": "string",
                          "displayOrder": 0,
                          "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "properties": [
                            "string"
                          ]
                        },
                        "clientProperties": [
                          "string"
                        ],
                        "loanScenarios": [
                          "string"
                        ],
                        "loans": [
                          "string"
                        ],
                        "publicRecordRequests": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "publicRecordProviderId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "hdpropertyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "publicRecordProviderRequestId": "string",
                            "requestorId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "requestorType": "string",
                            "requestStatus": "string",
                            "createdTimestamp": "2024-01-03T23:40:21.115Z",
                            "failureMessage": "string",
                            "hdproperty": "string",
                            "publicRecordProvider": {
                              "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                              "name": "string",
                              "publicRecordRequests": [
                                "string"
                              ]
                            }
                          }
                        ],
                        "avmProvider": {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "name": "string"
                        }
                      },
                      "residenceType": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "name": "string",
                        "lgvcode": "string",
                        "displayOrder": 0,
                        "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "clientProperties": [
                          "string"
                        ],
                        "loanScenarios": [
                          "string"
                        ],
                        "loans": [
                          "string"
                        ]
                      },
                      "opportunities": [
                        {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "loanId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "opportunityTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "paymentSavingThreshold": 0,
                          "paymentSavings": 0,
                          "mipmtSavingThreshold": 0,
                          "mipaymentSavings": 0,
                          "ltvthreshold": 0,
                          "estimatedLtv": 0,
                          "conformingThreshold": 0,
                          "estimatedBalance": 0,
                          "matchedRate": 0,
                          "matchedPrice": 0,
                          "marketPayment": 0,
                          "marketMonthlyPaymentMi": 0,
                          "loanTermMonths": 0,
                          "loanTypeName": "string",
                          "productName": "string",
                          "amortizationTypeName": "string",
                          "loanAmount": 0,
                          "armfixedTermMonths": 0,
                          "updatedTimestamp": "2024-01-03T23:40:21.115Z",
                          "estimatedCashOutLimit": 0,
                          "matchedApr": 0,
                          "pricingId": 0,
                          "loanPurpose": "string",
                          "createdTimeStamp": "2024-01-03T23:40:21.115Z",
                          "productIndex": "string",
                          "productCode": "string",
                          "lockPeriod": 0,
                          "priceStatus": "string",
                          "loanScenarioId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "adjustedApr": 0,
                          "adjustedFee": 0,
                          "armmargin": 0,
                          "armindexValue": 0,
                          "armsubsequentChangePeriod": "string",
                          "armfirstCap": 0,
                          "armperiodicCap": 0,
                          "armlifetimeCap": 0,
                          "armindexName": "string",
                          "points": 0,
                          "pointsCost": 0,
                          "closingCost": 0,
                          "client": "string",
                          "loan": "string",
                          "loanScenario": "string",
                          "opportunityType": {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "name": "string",
                            "shortName": "string",
                            "displayOrder": 0
                          }
                        }
                      ],
                      "pricingRequests": [
                        {
                          "id": 0,
                          "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "loanId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "createdTimeStamp": "2024-01-03T23:40:21.115Z",
                          "borrowerApplicationDate": "2024-01-03T23:40:21.115Z",
                          "assetDocumentation": "string",
                          "bankruptcy": "string",
                          "bankruptcyChapter": "string",
                          "bankStatementsForIncome": "string",
                          "citizenshipResidencyType": "string",
                          "borrowerTotalDebtExpenseRatioPercent": 0,
                          "borrowerDisclosureDate": "2024-01-03T23:40:21.115Z",
                          "employmentDocumentation": "string",
                          "fico": 0,
                          "borrowerFirstTimeHomebuyerIndicator": "string",
                          "foreclosure": "string",
                          "incomeDocumentation": "string",
                          "borrowerMonthlyIncome": 0,
                          "monthsReserves": 0,
                          "mortgageLatesRolling": 0,
                          "numberOf120DayLatesInLastYear": 0,
                          "numberOf30DayLatesInLastYear": 0,
                          "numberOf60DayLatesInLastYear": 0,
                          "numberOf90DayLatesInLastYear": 0,
                          "borrowerPledgedAssets": "string",
                          "selfEmployedIndicator": "string",
                          "typeOfVeteran": "string",
                          "vafirstTimeUse": "string",
                          "escrowWaiverIndicator": "string",
                          "coBorrowerNonOccupyingIndicator": "string",
                          "desiredAmortizationType": "string",
                          "desiredMonthsToFirstRateAdjustment": "string",
                          "automatedUnderwritingSystemName": "string",
                          "loanAmount": 0,
                          "borrowerPaysRequiredMiindicator": "str",
                          "temporaryBuydown": "string",
                          "calculateTotalLoanAmount": "string",
                          "refinanceCashOutAmount": 0,
                          "desiredLockPeriod": 0,
                          "desiredPrice": 0,
                          "desiredRate": 0,
                          "exemptFromVafundingFee": "string",
                          "expandedApprovalLevel": "string",
                          "feesIn": "str",
                          "fhacaseNumberAssignmentDate": "2024-01-03T23:40:21.115Z",
                          "fhacaseNumberEndorsmentDate": "2024-01-03T23:40:21.115Z",
                          "helocdrawnAmount": 0,
                          "heloclineAmount": 0,
                          "includeLocompensationInPricing": "string",
                          "interestOnlyIndicator": "string",
                          "interestOnlyTermMonths": 0,
                          "lienPosition": "string",
                          "loanPurpose": "string",
                          "desiredLoanTermMonths": "string",
                          "desiredLoanType": "string",
                          "prepayPenalty": "string",
                          "subordinateLienSecondAmount": 0,
                          "propertyValuationAmount": 0,
                          "construction": "string",
                          "corporateRelocation": "string",
                          "propertyCountyName": "string",
                          "storiesCount": 0,
                          "financedUnitCount": "string",
                          "propertyUsageType": "string",
                          "propertyType": "string",
                          "purchasePriceAmount": 0,
                          "propertyStateName": "string",
                          "loanScenarioId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "client": "string",
                          "loan": "string",
                          "loanScenario": "string",
                          "pricingResults": [
                            {
                              "id": 0,
                              "pricingRequestId": 0,
                              "createdTimeStamp": "2024-01-03T23:40:21.115Z",
                              "updatedTimestamp": "2024-01-03T23:40:21.115Z",
                              "productName": "string",
                              "productIndex": "string",
                              "productCode": "string",
                              "amortizationTermMonths": 0,
                              "amortizationTypeName": "string",
                              "armabsoluteCap": 0,
                              "armfirstCap": 0,
                              "armfixedTermMonths": 0,
                              "armindexName": "string",
                              "armperiodicCap": 0,
                              "armrelativeCap": 0,
                              "fhaupfrontPremiumAmount": 0,
                              "investorEntityIndex": 0,
                              "investorEntityName": "string",
                              "loanTermMonths": 0,
                              "loanTypeName": "string",
                              "lockPeriod": 0,
                              "margin": 0,
                              "miannualPremiumAmount": 0,
                              "mimonthlyPremiumAmount": 0,
                              "mimonthlyPremiumPercent": 0,
                              "mirequiredForLoan": "string",
                              "originationApr": 0,
                              "originationPandI": 0,
                              "originationTotalClosingCost": 0,
                              "price": 0,
                              "rate": 0,
                              "totalMarginAdjustment": 0,
                              "totalPriceAdjustment": 0,
                              "totalRateAdjustment": 0,
                              "totalSrpadjustment": 0,
                              "discount": 0,
                              "rebate": 0,
                              "totalCredit": 0,
                              "loanTermYears": 0,
                              "armFixedTermYears": 0,
                              "totalPayment": 0,
                              "priceStatus": "string",
                              "isAgentSelected": true,
                              "adjustedApr": 0,
                              "adjustedFee": 0,
                              "armmargin": 0,
                              "armindexValue": 0,
                              "armsubsequentChangePeriod": "string",
                              "points": 0,
                              "pointsCost": 0,
                              "closingCost": 0,
                              "pricingRequest": "string",
                              "pricingResultFees": [
                                {
                                  "id": 0,
                                  "pricingResultId": 0,
                                  "amount": 0,
                                  "description": "string",
                                  "isOrigination": true,
                                  "points": 0,
                                  "type": "string",
                                  "pricingResult": "string"
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "nonHomeLoans": [
                    {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "balance": 0,
                      "rate": 0,
                      "monthlyPayment": 0,
                      "nonHomeLoanType": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "createdTimestamp": "2024-01-03T23:40:21.115Z",
                      "updatedTimestamp": "2024-01-03T23:40:21.115Z",
                      "client": "string",
                      "nonHomeLoanTypeNavigation": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "name": "string",
                        "nonHomeLoans": [
                          "string"
                        ]
                      },
                      "clientNonHomeLoans": [
                        "string"
                      ]
                    }
                  ],
                  "opportunities": [
                    {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "loanId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "opportunityTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "paymentSavingThreshold": 0,
                      "paymentSavings": 0,
                      "mipmtSavingThreshold": 0,
                      "mipaymentSavings": 0,
                      "ltvthreshold": 0,
                      "estimatedLtv": 0,
                      "conformingThreshold": 0,
                      "estimatedBalance": 0,
                      "matchedRate": 0,
                      "matchedPrice": 0,
                      "marketPayment": 0,
                      "marketMonthlyPaymentMi": 0,
                      "loanTermMonths": 0,
                      "loanTypeName": "string",
                      "productName": "string",
                      "amortizationTypeName": "string",
                      "loanAmount": 0,
                      "armfixedTermMonths": 0,
                      "updatedTimestamp": "2024-01-03T23:40:21.115Z",
                      "estimatedCashOutLimit": 0,
                      "matchedApr": 0,
                      "pricingId": 0,
                      "loanPurpose": "string",
                      "createdTimeStamp": "2024-01-03T23:40:21.115Z",
                      "productIndex": "string",
                      "productCode": "string",
                      "lockPeriod": 0,
                      "priceStatus": "string",
                      "loanScenarioId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "adjustedApr": 0,
                      "adjustedFee": 0,
                      "armmargin": 0,
                      "armindexValue": 0,
                      "armsubsequentChangePeriod": "string",
                      "armfirstCap": 0,
                      "armperiodicCap": 0,
                      "armlifetimeCap": 0,
                      "armindexName": "string",
                      "points": 0,
                      "pointsCost": 0,
                      "closingCost": 0,
                      "client": "string",
                      "loan": "string",
                      "loanScenario": "string",
                      "opportunityType": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "name": "string",
                        "shortName": "string",
                        "displayOrder": 0
                      }
                    }
                  ],
                  "pricingRequests": [
                    {
                      "id": 0,
                      "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "loanId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "createdTimeStamp": "2024-01-03T23:40:21.115Z",
                      "borrowerApplicationDate": "2024-01-03T23:40:21.115Z",
                      "assetDocumentation": "string",
                      "bankruptcy": "string",
                      "bankruptcyChapter": "string",
                      "bankStatementsForIncome": "string",
                      "citizenshipResidencyType": "string",
                      "borrowerTotalDebtExpenseRatioPercent": 0,
                      "borrowerDisclosureDate": "2024-01-03T23:40:21.115Z",
                      "employmentDocumentation": "string",
                      "fico": 0,
                      "borrowerFirstTimeHomebuyerIndicator": "string",
                      "foreclosure": "string",
                      "incomeDocumentation": "string",
                      "borrowerMonthlyIncome": 0,
                      "monthsReserves": 0,
                      "mortgageLatesRolling": 0,
                      "numberOf120DayLatesInLastYear": 0,
                      "numberOf30DayLatesInLastYear": 0,
                      "numberOf60DayLatesInLastYear": 0,
                      "numberOf90DayLatesInLastYear": 0,
                      "borrowerPledgedAssets": "string",
                      "selfEmployedIndicator": "string",
                      "typeOfVeteran": "string",
                      "vafirstTimeUse": "string",
                      "escrowWaiverIndicator": "string",
                      "coBorrowerNonOccupyingIndicator": "string",
                      "desiredAmortizationType": "string",
                      "desiredMonthsToFirstRateAdjustment": "string",
                      "automatedUnderwritingSystemName": "string",
                      "loanAmount": 0,
                      "borrowerPaysRequiredMiindicator": "str",
                      "temporaryBuydown": "string",
                      "calculateTotalLoanAmount": "string",
                      "refinanceCashOutAmount": 0,
                      "desiredLockPeriod": 0,
                      "desiredPrice": 0,
                      "desiredRate": 0,
                      "exemptFromVafundingFee": "string",
                      "expandedApprovalLevel": "string",
                      "feesIn": "str",
                      "fhacaseNumberAssignmentDate": "2024-01-03T23:40:21.115Z",
                      "fhacaseNumberEndorsmentDate": "2024-01-03T23:40:21.115Z",
                      "helocdrawnAmount": 0,
                      "heloclineAmount": 0,
                      "includeLocompensationInPricing": "string",
                      "interestOnlyIndicator": "string",
                      "interestOnlyTermMonths": 0,
                      "lienPosition": "string",
                      "loanPurpose": "string",
                      "desiredLoanTermMonths": "string",
                      "desiredLoanType": "string",
                      "prepayPenalty": "string",
                      "subordinateLienSecondAmount": 0,
                      "propertyValuationAmount": 0,
                      "construction": "string",
                      "corporateRelocation": "string",
                      "propertyCountyName": "string",
                      "storiesCount": 0,
                      "financedUnitCount": "string",
                      "propertyUsageType": "string",
                      "propertyType": "string",
                      "purchasePriceAmount": 0,
                      "propertyStateName": "string",
                      "loanScenarioId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "client": "string",
                      "loan": "string",
                      "loanScenario": "string",
                      "pricingResults": [
                        {
                          "id": 0,
                          "pricingRequestId": 0,
                          "createdTimeStamp": "2024-01-03T23:40:21.115Z",
                          "updatedTimestamp": "2024-01-03T23:40:21.115Z",
                          "productName": "string",
                          "productIndex": "string",
                          "productCode": "string",
                          "amortizationTermMonths": 0,
                          "amortizationTypeName": "string",
                          "armabsoluteCap": 0,
                          "armfirstCap": 0,
                          "armfixedTermMonths": 0,
                          "armindexName": "string",
                          "armperiodicCap": 0,
                          "armrelativeCap": 0,
                          "fhaupfrontPremiumAmount": 0,
                          "investorEntityIndex": 0,
                          "investorEntityName": "string",
                          "loanTermMonths": 0,
                          "loanTypeName": "string",
                          "lockPeriod": 0,
                          "margin": 0,
                          "miannualPremiumAmount": 0,
                          "mimonthlyPremiumAmount": 0,
                          "mimonthlyPremiumPercent": 0,
                          "mirequiredForLoan": "string",
                          "originationApr": 0,
                          "originationPandI": 0,
                          "originationTotalClosingCost": 0,
                          "price": 0,
                          "rate": 0,
                          "totalMarginAdjustment": 0,
                          "totalPriceAdjustment": 0,
                          "totalRateAdjustment": 0,
                          "totalSrpadjustment": 0,
                          "discount": 0,
                          "rebate": 0,
                          "totalCredit": 0,
                          "loanTermYears": 0,
                          "armFixedTermYears": 0,
                          "totalPayment": 0,
                          "priceStatus": "string",
                          "isAgentSelected": true,
                          "adjustedApr": 0,
                          "adjustedFee": 0,
                          "armmargin": 0,
                          "armindexValue": 0,
                          "armsubsequentChangePeriod": "string",
                          "points": 0,
                          "pointsCost": 0,
                          "closingCost": 0,
                          "pricingRequest": "string",
                          "pricingResultFees": [
                            {
                              "id": 0,
                              "pricingResultId": 0,
                              "amount": 0,
                              "description": "string",
                              "isOrigination": true,
                              "points": 0,
                              "type": "string",
                              "pricingResult": "string"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                "loan": {
                  "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "propertyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "appraisedValue": 0,
                  "hoadues": 0,
                  "floodInsurance": 0,
                  "hazardInsuranceCompany": "string",
                  "hazardInsurance": 0,
                  "settlementCompany": "string",
                  "totalMonthlyPayment": 0,
                  "purchasePrice": 0,
                  "purchaseDate": "2024-01-03T23:40:21.115Z",
                  "appraisalDate": "2024-01-03T23:40:21.115Z",
                  "totalLoanAmount": 0,
                  "interestRate": 0,
                  "loanTerm": 0,
                  "monthlyPayment": 0,
                  "loanPurposeTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "purposeRefinanceTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "refinanceTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "lienTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "amortizationTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "programId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "armindex": 0,
                  "armadjustmentCap": 0,
                  "armfirstChangeMonths": 0,
                  "armmargin": 0,
                  "armlifeCap": 0,
                  "armfirstAdjustmentCap": 0,
                  "apr": 0,
                  "firstPaymentDate": "2024-01-03T23:40:21.115Z",
                  "lastPaymentDate": "2024-01-03T23:40:21.115Z",
                  "monthlyMortgageInsurance": 0,
                  "closingDate": "2024-01-03T23:40:21.115Z",
                  "hudescrowMonthlyPayment": 0,
                  "loanTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "nmlsloanTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "upfrontMipPercentage": 0,
                  "nmlsid": "string",
                  "lenderNmlsid": "string",
                  "loanNumber": "string",
                  "lenderCaseNumber": "string",
                  "subjectPropertyAddress": "string",
                  "subjectPropertyCity": "string",
                  "subjectPropertyState": "string",
                  "subjectPropertyZip": "string",
                  "propertyTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "yearBuilt": 0,
                  "numberOfBedroom": 0,
                  "numberOfBath": 0,
                  "homeSize": 0,
                  "lotSize": 0,
                  "yearAcquired": 0,
                  "parcelNumber": "string",
                  "sellersAgentCompany": "string",
                  "sellersAgentAddress": "string",
                  "sellersAgentCity": "string",
                  "sellersAgentState": "string",
                  "sellersAgentZip": "string",
                  "sellersAgentCompanyLicenseNumber": "string",
                  "sellersAgentName": "string",
                  "sellersAgentLicenseNumber": "string",
                  "sellersAgentEmail": "string",
                  "sellersAgentPhone": "string",
                  "residenceTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "externalId": "string",
                  "createdTimestamp": "2024-01-03T23:40:21.115Z",
                  "updatedTimestamp": "2024-01-03T23:40:21.115Z",
                  "lmcreditScore": 0,
                  "respaApplicationDate": "2024-01-03T23:40:21.115Z",
                  "ltv": 0,
                  "firstInterestChangeDate": "2024-01-03T23:40:21.115Z",
                  "indexTypeCode": "string",
                  "totalMargin": 0,
                  "indexValue": 0,
                  "lifeFloor": 0,
                  "lifeTimeCap": 0,
                  "firstAdjustmentCap": 0,
                  "periodicCap": 0,
                  "amortTerm": 0,
                  "interestAdjustPeriod": 0,
                  "externalLoanSource": "string",
                  "alreadyRefinanced": true,
                  "alreadySold": true,
                  "alreadyRefinancedAnotherLender": true,
                  "earlyPayoffDate": "2024-01-03T23:40:21.115Z",
                  "clientInterestRate": 0,
                  "clientPurchasePrice": 0,
                  "clientEstimatedBalance": 0,
                  "clientMonthlyMortgageInsurance": 0,
                  "clientEstimatedBalanceUpdatedTimestamp": "2024-01-03T23:40:21.115Z",
                  "otherLoanBalance": 0,
                  "encompassId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "isActive": true,
                  "lastDataTraceLoanConfirmTimeStamp": "2024-01-03T23:40:21.115Z",
                  "lastDataTraceCheckupTimeStamp": "2024-01-03T23:40:21.115Z",
                  "lastPublicRecordConfirmDate": "2024-01-03T23:40:21.115Z",
                  "lender": "string",
                  "isLoanRemoved": true,
                  "amortizationType": {
                    "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "name": "string",
                    "displayOrder": 0,
                    "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "loans": [
                      "string"
                    ]
                  },
                  "lienType": {
                    "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "name": "string",
                    "displayOrder": 0,
                    "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "loans": [
                      "string"
                    ]
                  },
                  "loanPurposeType": {
                    "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "name": "string",
                    "displayOrder": 0,
                    "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "loans": [
                      "string"
                    ]
                  },
                  "nmlsloanType": {
                    "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "name": "string",
                    "displayOrder": 0,
                    "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "loans": [
                      "string"
                    ]
                  },
                  "program": {
                    "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "name": "string",
                    "displayOrder": 0,
                    "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "loans": [
                      "string"
                    ]
                  },
                  "property": {
                    "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "address": "string",
                    "city": "string",
                    "state": "string",
                    "zip": "string",
                    "propertyTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "yearBuilt": 0,
                    "parcelNumber": "string",
                    "coreLogicPropertyId": "string",
                    "county": "string",
                    "ownerName": "string",
                    "avmestimatedValue": 0,
                    "avmlowValue": 0,
                    "avmhighValue": 0,
                    "avmprocessedDate": "2024-01-03T23:40:21.115Z",
                    "avmforecastStandardDeviation": 0,
                    "apn": "string",
                    "landUse": "string",
                    "landUseCode": "string",
                    "censusTract": "string",
                    "absenteeOwner": true,
                    "latitude": 0,
                    "longitude": 0,
                    "standardLandUse": "string",
                    "standardLandUseCode": "string",
                    "livingArea": 0,
                    "totalRooms": 0,
                    "bedrooms": 0,
                    "fullBath": 0,
                    "halfBath": 0,
                    "totalBaths": 0,
                    "pool": true,
                    "numberOfStories": 0,
                    "lotArea": 0,
                    "effectiveYearBuilt": 0,
                    "airConditioning": true,
                    "fireplace": 0,
                    "parking": 0,
                    "propertyValuationId": "string",
                    "propertyValuationIdSearchSuccessful": true,
                    "lastPropertyValuationSearch": "2024-01-03T23:40:21.115Z",
                    "clientEstimatedValue": 0,
                    "clientEstimatedValueDelta": 0,
                    "clientEstimatedValueUpdatedTimestamp": "2024-01-03T23:40:21.115Z",
                    "clientEstimatedValueUpdatedBy": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "marketValueHistoryUpdatedTimestamp": "2024-01-03T23:40:21.115Z",
                    "createdTimestamp": "2024-01-03T23:40:21.115Z",
                    "updatedTimestamp": "2024-01-03T23:40:21.115Z",
                    "marketValueUpdatedTimestamp": "2024-01-03T23:40:21.115Z",
                    "isMarketValueUpdatedByScheduler": true,
                    "source": "string",
                    "dataTracePropertyId": 0,
                    "qvmPropertyId": 0,
                    "qvmSearchTimestamp": "2024-01-03T23:40:21.115Z",
                    "qvmSearchResultsCount": 0,
                    "sourceAddress": "string",
                    "sourceCity": "string",
                    "sourceState": "string",
                    "sourceZip": "string",
                    "sourceCounty": "string",
                    "lastPublicRecordCheckupDate": "2024-01-03T23:40:21.115Z",
                    "basementArea": 0,
                    "zoning": "string",
                    "neighborhoodName": "string",
                    "schoolDistrict": "string",
                    "elementarySchool": "string",
                    "middleSchool": "string",
                    "highSchool": "string",
                    "salePrice": 0,
                    "saleDate": "2024-01-03T23:40:21.115Z",
                    "taxYear": 0,
                    "propertyTax": 0,
                    "assessedValue": 0,
                    "garage": "string",
                    "garageParkingSpaceCount": 0,
                    "avmProviderId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "propertyType": {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "name": "string",
                      "displayOrder": 0,
                      "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "properties": [
                        "string"
                      ]
                    },
                    "clientProperties": [
                      "string"
                    ],
                    "loanScenarios": [
                      "string"
                    ],
                    "loans": [
                      "string"
                    ],
                    "publicRecordRequests": [
                      {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "publicRecordProviderId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "hdpropertyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "publicRecordProviderRequestId": "string",
                        "requestorId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "requestorType": "string",
                        "requestStatus": "string",
                        "createdTimestamp": "2024-01-03T23:40:21.115Z",
                        "failureMessage": "string",
                        "hdproperty": "string",
                        "publicRecordProvider": {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "name": "string",
                          "publicRecordRequests": [
                            "string"
                          ]
                        }
                      }
                    ],
                    "avmProvider": {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "name": "string"
                    }
                  },
                  "purposeRefinanceType": {
                    "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "name": "string",
                    "displayOrder": 0,
                    "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "loans": [
                      "string"
                    ]
                  },
                  "refinanceType": {
                    "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "name": "string",
                    "displayOrder": 0,
                    "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "loans": [
                      "string"
                    ]
                  },
                  "residenceType": {
                    "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "name": "string",
                    "lgvcode": "string",
                    "displayOrder": 0,
                    "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "clientProperties": [
                      "string"
                    ],
                    "loanScenarios": [
                      "string"
                    ],
                    "loans": [
                      "string"
                    ]
                  },
                  "clientLoans": [
                    {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "loanId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "isPrimaryBorrower": true,
                      "loan": "string"
                    }
                  ],
                  "loanAnalyses": [
                    {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "loanId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "ownerId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "creditScore": 0,
                      "loanOrigination": "2024-01-03T23:40:21.115Z",
                      "closedDate": "2024-01-03T23:40:21.115Z",
                      "interestRate": 0,
                      "monthlyInterestRate": 0,
                      "totalMortgageLoanAmount": 0,
                      "appraisalValue": 0,
                      "loanPurpose": "string",
                      "loanTerm": 0,
                      "loanType": "string",
                      "progType": "string",
                      "ownerOccupied": "str",
                      "ltv": 0,
                      "ltvthreshold": 0,
                      "analysisPaymentSavingThreshold": 0,
                      "analysisConformingThreshold": 0,
                      "analysisMipmtSavingThreshold": 0,
                      "armfirstAdjustmentDate": "2024-01-03T23:40:21.115Z",
                      "monthlyPaymentMi": 0,
                      "monthsAgoClosed": 0,
                      "loanPayment": 0,
                      "payment": 0,
                      "balanceNeededForLtv": 0,
                      "totalInterest": 0,
                      "totalPrincipal": 0,
                      "estimatedBalance": 0,
                      "deltaToLtv": 0,
                      "monthsToLtv": 0,
                      "monthForLtv": "2024-01-03T23:40:21.115Z",
                      "deltaToConforming": 0,
                      "monthsToConforming": 0,
                      "monthForConforming": "2024-01-03T23:40:21.115Z",
                      "yearToDatePrincipal": 0,
                      "yearToDateInterest": 0,
                      "lastYearPrincipal": 0,
                      "lastYearInterest": 0,
                      "remainingPrincipal": 0,
                      "remainingInterest": 0,
                      "estimatedLtv": 0,
                      "marketMonthlyPaymentMi": 0,
                      "totalPaymentWithMi": 0,
                      "estimatedCashOutLimit": 0,
                      "estimatedHomeValue": 0,
                      "estimatedLtvhomeValueBased": 0,
                      "marketMonthlyPaymentMifixed": 0,
                      "marketMonthlyPaymentMiarm": 0,
                      "notEligibleForOpportunity": true,
                      "combinedLoanBalance": 0,
                      "monthsSinceLastDataTraceCheckup": 0,
                      "loan": "string",
                      "owner": "string"
                    }
                  ],
                  "loanApplications": [
                    {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "loanId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "externalId": "string",
                      "createdOn": "2024-01-03T23:40:21.115Z",
                      "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "applicationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "application": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "name": "string",
                        "type": "string",
                        "applicationCompanies": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "applicationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "keyVaultUrl": "string",
                            "application": "string",
                            "company": "string"
                          }
                        ],
                        "applicationUsers": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "applicationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "indexName": "string",
                            "indexValue": "string",
                            "application": "string",
                            "user": "string"
                          }
                        ],
                        "loanApplications": [
                          "string"
                        ]
                      },
                      "client": "string",
                      "company": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "businessTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "name": "string",
                        "dbaname": "string",
                        "address1": "string",
                        "address2": "string",
                        "city": "string",
                        "state": "string",
                        "zipCode": "string",
                        "phone": "string",
                        "fax": "string",
                        "website": "string",
                        "nmlsid": "string",
                        "licenseNumber": "string",
                        "companyLogoUrl": "string",
                        "companyEmail": "string",
                        "disclaimer": "string",
                        "isDisabled": true,
                        "externalId": "string",
                        "createdTimestamp": "2024-01-03T23:40:21.115Z",
                        "updatedTimestamp": "2024-01-03T23:40:21.115Z",
                        "companyCode": "string",
                        "ftpfolder": "string",
                        "displayName": "string",
                        "businessType": {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "name": "string",
                          "displayOrder": 0,
                          "companies": [
                            "string"
                          ]
                        },
                        "applicationCompanies": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "applicationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "keyVaultUrl": "string",
                            "application": "string",
                            "company": "string"
                          }
                        ],
                        "bestPricings": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "desiredAmortizationType": "string",
                            "desiredLoanTermMonths": "string",
                            "desiredLoanType": "string",
                            "desiredLoanPurpose": "string",
                            "ltv": 0,
                            "loanAmount": 0,
                            "propertyValuationAmount": 0,
                            "purchasePriceAmount": 0,
                            "productName": "string",
                            "productIndex": "string",
                            "productCode": "string",
                            "amortizationTermMonths": 0,
                            "amortizationTypeName": "string",
                            "armabsoluteCap": 0,
                            "armfirstCap": 0,
                            "armfixedTermMonths": 0,
                            "armindexName": "string",
                            "armperiodicCap": 0,
                            "armrelativeCap": 0,
                            "fhaupfrontPremiumAmount": 0,
                            "investorEntityIndex": 0,
                            "investorEntityName": "string",
                            "loanTermMonths": 0,
                            "loanTypeName": "string",
                            "lockPeriod": 0,
                            "margin": 0,
                            "miannualPremiumAmount": 0,
                            "mimonthlyPremiumAmount": 0,
                            "mimonthlyPremiumPercent": 0,
                            "mirequiredForLoan": "string",
                            "originationApr": 0,
                            "originationPandI": 0,
                            "originationTotalClosingCost": 0,
                            "price": 0,
                            "rate": 0,
                            "totalMarginAdjustment": 0,
                            "totalPriceAdjustment": 0,
                            "totalRateAdjustment": 0,
                            "totalSrpadjustment": 0,
                            "updatedTimestamp": "2024-01-03T23:40:21.116Z",
                            "company": "string"
                          }
                        ],
                        "loanApplications": [
                          "string"
                        ],
                        "organizations": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "name": "string",
                            "address1": "string",
                            "address2": "string",
                            "city": "string",
                            "state": "string",
                            "zipCode": "string",
                            "phone": "string",
                            "fax": "string",
                            "nmlsid": "string",
                            "licenseNumber": "string",
                            "organizationLogoUrl": "string",
                            "organizationEmail": "string",
                            "disclaimer": "string",
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "isDisabled": true,
                            "externalId": "string",
                            "createdTimestamp": "2024-01-03T23:40:21.116Z",
                            "updatedTimestamp": "2024-01-03T23:40:21.116Z",
                            "coBrandingAgentId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "coBrandingAgent": "string",
                            "company": "string",
                            "users": [
                              "string"
                            ]
                          }
                        ],
                        "pageAccesses": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "pageId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "rolename": "string",
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "company": "string",
                            "page": {
                              "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                              "key": "string",
                              "pageCategoryId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                              "title": "string",
                              "path": "string",
                              "sortOrder": 0,
                              "isDeleted": true,
                              "screenLoadMethodId": 0,
                              "pageCategory": {
                                "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                                "key": "string",
                                "title": "string",
                                "sortOrder": 0,
                                "faIcon": "string",
                                "pages": [
                                  "string"
                                ]
                              },
                              "screenLoadMethod": {
                                "id": 0,
                                "description": "string",
                                "pages": [
                                  "string"
                                ]
                              },
                              "pageAccesses": [
                                "string"
                              ]
                            }
                          }
                        ],
                        "pricingConfigs": [
                          {
                            "id": 0,
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "loanTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "defaultRequestPayload": "string",
                            "company": "string",
                            "loanType": {
                              "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                              "name": "string",
                              "displayOrder": 0,
                              "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                              "pricingConfigs": [
                                "string"
                              ]
                            }
                          }
                        ],
                        "pricings": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "desiredAmortizationType": "string",
                            "desiredLoanTermMonths": "string",
                            "desiredLoanType": "string",
                            "desiredLoanPurpose": "string",
                            "ltv": 0,
                            "loanAmount": 0,
                            "propertyValuationAmount": 0,
                            "purchasePriceAmount": 0,
                            "productName": "string",
                            "productIndex": "string",
                            "productCode": "string",
                            "amortizationTermMonths": 0,
                            "amortizationTypeName": "string",
                            "armabsoluteCap": 0,
                            "armfirstCap": 0,
                            "armfixedTermMonths": 0,
                            "armindexName": "string",
                            "armperiodicCap": 0,
                            "armrelativeCap": 0,
                            "fhaupfrontPremiumAmount": 0,
                            "investorEntityIndex": 0,
                            "investorEntityName": "string",
                            "loanTermMonths": 0,
                            "loanTypeName": "string",
                            "lockPeriod": 0,
                            "margin": 0,
                            "miannualPremiumAmount": 0,
                            "mimonthlyPremiumAmount": 0,
                            "mimonthlyPremiumPercent": 0,
                            "mirequiredForLoan": "string",
                            "originationApr": 0,
                            "originationPandI": 0,
                            "originationTotalClosingCost": 0,
                            "price": 0,
                            "rate": 0,
                            "totalMarginAdjustment": 0,
                            "totalPriceAdjustment": 0,
                            "totalRateAdjustment": 0,
                            "totalSrpadjustment": 0,
                            "updatedTimestamp": "2024-01-03T23:40:21.116Z",
                            "discount": 0,
                            "rebate": 0,
                            "totalCredit": 0,
                            "company": "string"
                          }
                        ],
                        "sendGridTemplates": [
                          {
                            "id": 0,
                            "companyName": "string",
                            "templateName": "string",
                            "templateId": "string",
                            "apikey": "string",
                            "isWelcome": true,
                            "isActive": true,
                            "unsubscribeGroupId": 0,
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "company": "string"
                          }
                        ],
                        "userFileUploads": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "importTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "statusId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "fileUploadDateTime": "2024-01-03T23:40:21.116Z",
                            "fileUploadName": "string",
                            "result": "string",
                            "company": "string",
                            "importType": {
                              "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                              "name": "string",
                              "userFileUploads": [
                                "string"
                              ]
                            },
                            "status": {
                              "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                              "name": "string",
                              "userFileUploads": [
                                "string"
                              ]
                            },
                            "user": "string"
                          }
                        ],
                        "users": [
                          "string"
                        ],
                        "lenderPartnerCompanyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "companySocialMedia": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "socialMediaTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "link": "string",
                            "createdDateTime": "2024-01-03T23:40:21.116Z",
                            "updatedDateTime": "2024-01-03T23:40:21.116Z",
                            "company": "string"
                          }
                        ],
                        "userInvites": [
                          {
                            "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "senderUserId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "assignedCompanyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                            "firstName": "string",
                            "lastName": "string",
                            "email": "string",
                            "inviteDateTime": "2024-01-03T23:40:21.116Z",
                            "hasAcceptedTerms": true,
                            "acceptedTermsDateTime": "2024-01-03T23:40:21.116Z",
                            "assignedCompany": "string",
                            "senderUser": "string"
                          }
                        ]
                      },
                      "loan": "string"
                    }
                  ],
                  "opportunities": [
                    {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "loanId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "opportunityTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "paymentSavingThreshold": 0,
                      "paymentSavings": 0,
                      "mipmtSavingThreshold": 0,
                      "mipaymentSavings": 0,
                      "ltvthreshold": 0,
                      "estimatedLtv": 0,
                      "conformingThreshold": 0,
                      "estimatedBalance": 0,
                      "matchedRate": 0,
                      "matchedPrice": 0,
                      "marketPayment": 0,
                      "marketMonthlyPaymentMi": 0,
                      "loanTermMonths": 0,
                      "loanTypeName": "string",
                      "productName": "string",
                      "amortizationTypeName": "string",
                      "loanAmount": 0,
                      "armfixedTermMonths": 0,
                      "updatedTimestamp": "2024-01-03T23:40:21.116Z",
                      "estimatedCashOutLimit": 0,
                      "matchedApr": 0,
                      "pricingId": 0,
                      "loanPurpose": "string",
                      "createdTimeStamp": "2024-01-03T23:40:21.116Z",
                      "productIndex": "string",
                      "productCode": "string",
                      "lockPeriod": 0,
                      "priceStatus": "string",
                      "loanScenarioId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "adjustedApr": 0,
                      "adjustedFee": 0,
                      "armmargin": 0,
                      "armindexValue": 0,
                      "armsubsequentChangePeriod": "string",
                      "armfirstCap": 0,
                      "armperiodicCap": 0,
                      "armlifetimeCap": 0,
                      "armindexName": "string",
                      "points": 0,
                      "pointsCost": 0,
                      "closingCost": 0,
                      "client": "string",
                      "loan": "string",
                      "loanScenario": "string",
                      "opportunityType": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "name": "string",
                        "shortName": "string",
                        "displayOrder": 0
                      }
                    }
                  ],
                  "pricingRequests": [
                    {
                      "id": 0,
                      "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "loanId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "createdTimeStamp": "2024-01-03T23:40:21.116Z",
                      "borrowerApplicationDate": "2024-01-03T23:40:21.116Z",
                      "assetDocumentation": "string",
                      "bankruptcy": "string",
                      "bankruptcyChapter": "string",
                      "bankStatementsForIncome": "string",
                      "citizenshipResidencyType": "string",
                      "borrowerTotalDebtExpenseRatioPercent": 0,
                      "borrowerDisclosureDate": "2024-01-03T23:40:21.116Z",
                      "employmentDocumentation": "string",
                      "fico": 0,
                      "borrowerFirstTimeHomebuyerIndicator": "string",
                      "foreclosure": "string",
                      "incomeDocumentation": "string",
                      "borrowerMonthlyIncome": 0,
                      "monthsReserves": 0,
                      "mortgageLatesRolling": 0,
                      "numberOf120DayLatesInLastYear": 0,
                      "numberOf30DayLatesInLastYear": 0,
                      "numberOf60DayLatesInLastYear": 0,
                      "numberOf90DayLatesInLastYear": 0,
                      "borrowerPledgedAssets": "string",
                      "selfEmployedIndicator": "string",
                      "typeOfVeteran": "string",
                      "vafirstTimeUse": "string",
                      "escrowWaiverIndicator": "string",
                      "coBorrowerNonOccupyingIndicator": "string",
                      "desiredAmortizationType": "string",
                      "desiredMonthsToFirstRateAdjustment": "string",
                      "automatedUnderwritingSystemName": "string",
                      "loanAmount": 0,
                      "borrowerPaysRequiredMiindicator": "str",
                      "temporaryBuydown": "string",
                      "calculateTotalLoanAmount": "string",
                      "refinanceCashOutAmount": 0,
                      "desiredLockPeriod": 0,
                      "desiredPrice": 0,
                      "desiredRate": 0,
                      "exemptFromVafundingFee": "string",
                      "expandedApprovalLevel": "string",
                      "feesIn": "str",
                      "fhacaseNumberAssignmentDate": "2024-01-03T23:40:21.116Z",
                      "fhacaseNumberEndorsmentDate": "2024-01-03T23:40:21.116Z",
                      "helocdrawnAmount": 0,
                      "heloclineAmount": 0,
                      "includeLocompensationInPricing": "string",
                      "interestOnlyIndicator": "string",
                      "interestOnlyTermMonths": 0,
                      "lienPosition": "string",
                      "loanPurpose": "string",
                      "desiredLoanTermMonths": "string",
                      "desiredLoanType": "string",
                      "prepayPenalty": "string",
                      "subordinateLienSecondAmount": 0,
                      "propertyValuationAmount": 0,
                      "construction": "string",
                      "corporateRelocation": "string",
                      "propertyCountyName": "string",
                      "storiesCount": 0,
                      "financedUnitCount": "string",
                      "propertyUsageType": "string",
                      "propertyType": "string",
                      "purchasePriceAmount": 0,
                      "propertyStateName": "string",
                      "loanScenarioId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "client": "string",
                      "loan": "string",
                      "loanScenario": "string",
                      "pricingResults": [
                        {
                          "id": 0,
                          "pricingRequestId": 0,
                          "createdTimeStamp": "2024-01-03T23:40:21.116Z",
                          "updatedTimestamp": "2024-01-03T23:40:21.116Z",
                          "productName": "string",
                          "productIndex": "string",
                          "productCode": "string",
                          "amortizationTermMonths": 0,
                          "amortizationTypeName": "string",
                          "armabsoluteCap": 0,
                          "armfirstCap": 0,
                          "armfixedTermMonths": 0,
                          "armindexName": "string",
                          "armperiodicCap": 0,
                          "armrelativeCap": 0,
                          "fhaupfrontPremiumAmount": 0,
                          "investorEntityIndex": 0,
                          "investorEntityName": "string",
                          "loanTermMonths": 0,
                          "loanTypeName": "string",
                          "lockPeriod": 0,
                          "margin": 0,
                          "miannualPremiumAmount": 0,
                          "mimonthlyPremiumAmount": 0,
                          "mimonthlyPremiumPercent": 0,
                          "mirequiredForLoan": "string",
                          "originationApr": 0,
                          "originationPandI": 0,
                          "originationTotalClosingCost": 0,
                          "price": 0,
                          "rate": 0,
                          "totalMarginAdjustment": 0,
                          "totalPriceAdjustment": 0,
                          "totalRateAdjustment": 0,
                          "totalSrpadjustment": 0,
                          "discount": 0,
                          "rebate": 0,
                          "totalCredit": 0,
                          "loanTermYears": 0,
                          "armFixedTermYears": 0,
                          "totalPayment": 0,
                          "priceStatus": "string",
                          "isAgentSelected": true,
                          "adjustedApr": 0,
                          "adjustedFee": 0,
                          "armmargin": 0,
                          "armindexValue": 0,
                          "armsubsequentChangePeriod": "string",
                          "points": 0,
                          "pointsCost": 0,
                          "closingCost": 0,
                          "pricingRequest": "string",
                          "pricingResultFees": [
                            {
                              "id": 0,
                              "pricingResultId": 0,
                              "amount": 0,
                              "description": "string",
                              "isOrigination": true,
                              "points": 0,
                              "type": "string",
                              "pricingResult": "string"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                "loanScenario": {
                  "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "purchasePrice": 0,
                  "downPayment": 0,
                  "payDownPoints": true,
                  "createdOn": "2024-01-03T23:40:21.116Z",
                  "updatedOn": "2024-01-03T23:40:21.116Z",
                  "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "residenceTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "propertyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "loanAmount": 0,
                  "client": "string",
                  "property": {
                    "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "address": "string",
                    "city": "string",
                    "state": "string",
                    "zip": "string",
                    "propertyTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "yearBuilt": 0,
                    "parcelNumber": "string",
                    "coreLogicPropertyId": "string",
                    "county": "string",
                    "ownerName": "string",
                    "avmestimatedValue": 0,
                    "avmlowValue": 0,
                    "avmhighValue": 0,
                    "avmprocessedDate": "2024-01-03T23:40:21.116Z",
                    "avmforecastStandardDeviation": 0,
                    "apn": "string",
                    "landUse": "string",
                    "landUseCode": "string",
                    "censusTract": "string",
                    "absenteeOwner": true,
                    "latitude": 0,
                    "longitude": 0,
                    "standardLandUse": "string",
                    "standardLandUseCode": "string",
                    "livingArea": 0,
                    "totalRooms": 0,
                    "bedrooms": 0,
                    "fullBath": 0,
                    "halfBath": 0,
                    "totalBaths": 0,
                    "pool": true,
                    "numberOfStories": 0,
                    "lotArea": 0,
                    "effectiveYearBuilt": 0,
                    "airConditioning": true,
                    "fireplace": 0,
                    "parking": 0,
                    "propertyValuationId": "string",
                    "propertyValuationIdSearchSuccessful": true,
                    "lastPropertyValuationSearch": "2024-01-03T23:40:21.116Z",
                    "clientEstimatedValue": 0,
                    "clientEstimatedValueDelta": 0,
                    "clientEstimatedValueUpdatedTimestamp": "2024-01-03T23:40:21.116Z",
                    "clientEstimatedValueUpdatedBy": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "marketValueHistoryUpdatedTimestamp": "2024-01-03T23:40:21.116Z",
                    "createdTimestamp": "2024-01-03T23:40:21.116Z",
                    "updatedTimestamp": "2024-01-03T23:40:21.116Z",
                    "marketValueUpdatedTimestamp": "2024-01-03T23:40:21.116Z",
                    "isMarketValueUpdatedByScheduler": true,
                    "source": "string",
                    "dataTracePropertyId": 0,
                    "qvmPropertyId": 0,
                    "qvmSearchTimestamp": "2024-01-03T23:40:21.116Z",
                    "qvmSearchResultsCount": 0,
                    "sourceAddress": "string",
                    "sourceCity": "string",
                    "sourceState": "string",
                    "sourceZip": "string",
                    "sourceCounty": "string",
                    "lastPublicRecordCheckupDate": "2024-01-03T23:40:21.116Z",
                    "basementArea": 0,
                    "zoning": "string",
                    "neighborhoodName": "string",
                    "schoolDistrict": "string",
                    "elementarySchool": "string",
                    "middleSchool": "string",
                    "highSchool": "string",
                    "salePrice": 0,
                    "saleDate": "2024-01-03T23:40:21.116Z",
                    "taxYear": 0,
                    "propertyTax": 0,
                    "assessedValue": 0,
                    "garage": "string",
                    "garageParkingSpaceCount": 0,
                    "avmProviderId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "propertyType": {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "name": "string",
                      "displayOrder": 0,
                      "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "properties": [
                        "string"
                      ]
                    },
                    "clientProperties": [
                      "string"
                    ],
                    "loanScenarios": [
                      "string"
                    ],
                    "loans": [
                      "string"
                    ],
                    "publicRecordRequests": [
                      {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "publicRecordProviderId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "hdpropertyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "publicRecordProviderRequestId": "string",
                        "requestorId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "requestorType": "string",
                        "requestStatus": "string",
                        "createdTimestamp": "2024-01-03T23:40:21.116Z",
                        "failureMessage": "string",
                        "hdproperty": "string",
                        "publicRecordProvider": {
                          "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                          "name": "string",
                          "publicRecordRequests": [
                            "string"
                          ]
                        }
                      }
                    ],
                    "avmProvider": {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "name": "string"
                    }
                  },
                  "residenceType": {
                    "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "name": "string",
                    "lgvcode": "string",
                    "displayOrder": 0,
                    "companyId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "clientProperties": [
                      "string"
                    ],
                    "loanScenarios": [
                      "string"
                    ],
                    "loans": [
                      "string"
                    ]
                  },
                  "opportunities": [
                    {
                      "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "loanId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "opportunityTypeId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "paymentSavingThreshold": 0,
                      "paymentSavings": 0,
                      "mipmtSavingThreshold": 0,
                      "mipaymentSavings": 0,
                      "ltvthreshold": 0,
                      "estimatedLtv": 0,
                      "conformingThreshold": 0,
                      "estimatedBalance": 0,
                      "matchedRate": 0,
                      "matchedPrice": 0,
                      "marketPayment": 0,
                      "marketMonthlyPaymentMi": 0,
                      "loanTermMonths": 0,
                      "loanTypeName": "string",
                      "productName": "string",
                      "amortizationTypeName": "string",
                      "loanAmount": 0,
                      "armfixedTermMonths": 0,
                      "updatedTimestamp": "2024-01-03T23:40:21.116Z",
                      "estimatedCashOutLimit": 0,
                      "matchedApr": 0,
                      "pricingId": 0,
                      "loanPurpose": "string",
                      "createdTimeStamp": "2024-01-03T23:40:21.116Z",
                      "productIndex": "string",
                      "productCode": "string",
                      "lockPeriod": 0,
                      "priceStatus": "string",
                      "loanScenarioId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "adjustedApr": 0,
                      "adjustedFee": 0,
                      "armmargin": 0,
                      "armindexValue": 0,
                      "armsubsequentChangePeriod": "string",
                      "armfirstCap": 0,
                      "armperiodicCap": 0,
                      "armlifetimeCap": 0,
                      "armindexName": "string",
                      "points": 0,
                      "pointsCost": 0,
                      "closingCost": 0,
                      "client": "string",
                      "loan": "string",
                      "loanScenario": "string",
                      "opportunityType": {
                        "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                        "name": "string",
                        "shortName": "string",
                        "displayOrder": 0
                      }
                    }
                  ],
                  "pricingRequests": [
                    {
                      "id": 0,
                      "clientId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "loanId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "createdTimeStamp": "2024-01-03T23:40:21.116Z",
                      "borrowerApplicationDate": "2024-01-03T23:40:21.116Z",
                      "assetDocumentation": "string",
                      "bankruptcy": "string",
                      "bankruptcyChapter": "string",
                      "bankStatementsForIncome": "string",
                      "citizenshipResidencyType": "string",
                      "borrowerTotalDebtExpenseRatioPercent": 0,
                      "borrowerDisclosureDate": "2024-01-03T23:40:21.116Z",
                      "employmentDocumentation": "string",
                      "fico": 0,
                      "borrowerFirstTimeHomebuyerIndicator": "string",
                      "foreclosure": "string",
                      "incomeDocumentation": "string",
                      "borrowerMonthlyIncome": 0,
                      "monthsReserves": 0,
                      "mortgageLatesRolling": 0,
                      "numberOf120DayLatesInLastYear": 0,
                      "numberOf30DayLatesInLastYear": 0,
                      "numberOf60DayLatesInLastYear": 0,
                      "numberOf90DayLatesInLastYear": 0,
                      "borrowerPledgedAssets": "string",
                      "selfEmployedIndicator": "string",
                      "typeOfVeteran": "string",
                      "vafirstTimeUse": "string",
                      "escrowWaiverIndicator": "string",
                      "coBorrowerNonOccupyingIndicator": "string",
                      "desiredAmortizationType": "string",
                      "desiredMonthsToFirstRateAdjustment": "string",
                      "automatedUnderwritingSystemName": "string",
                      "loanAmount": 0,
                      "borrowerPaysRequiredMiindicator": "str",
                      "temporaryBuydown": "string",
                      "calculateTotalLoanAmount": "string",
                      "refinanceCashOutAmount": 0,
                      "desiredLockPeriod": 0,
                      "desiredPrice": 0,
                      "desiredRate": 0,
                      "exemptFromVafundingFee": "string",
                      "expandedApprovalLevel": "string",
                      "feesIn": "str",
                      "fhacaseNumberAssignmentDate": "2024-01-03T23:40:21.116Z",
                      "fhacaseNumberEndorsmentDate": "2024-01-03T23:40:21.116Z",
                      "helocdrawnAmount": 0,
                      "heloclineAmount": 0,
                      "includeLocompensationInPricing": "string",
                      "interestOnlyIndicator": "string",
                      "interestOnlyTermMonths": 0,
                      "lienPosition": "string",
                      "loanPurpose": "string",
                      "desiredLoanTermMonths": "string",
                      "desiredLoanType": "string",
                      "prepayPenalty": "string",
                      "subordinateLienSecondAmount": 0,
                      "propertyValuationAmount": 0,
                      "construction": "string",
                      "corporateRelocation": "string",
                      "propertyCountyName": "string",
                      "storiesCount": 0,
                      "financedUnitCount": "string",
                      "propertyUsageType": "string",
                      "propertyType": "string",
                      "purchasePriceAmount": 0,
                      "propertyStateName": "string",
                      "loanScenarioId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                      "client": "string",
                      "loan": "string",
                      "loanScenario": "string",
                      "pricingResults": [
                        {
                          "id": 0,
                          "pricingRequestId": 0,
                          "createdTimeStamp": "2024-01-03T23:40:21.116Z",
                          "updatedTimestamp": "2024-01-03T23:40:21.116Z",
                          "productName": "string",
                          "productIndex": "string",
                          "productCode": "string",
                          "amortizationTermMonths": 0,
                          "amortizationTypeName": "string",
                          "armabsoluteCap": 0,
                          "armfirstCap": 0,
                          "armfixedTermMonths": 0,
                          "armindexName": "string",
                          "armperiodicCap": 0,
                          "armrelativeCap": 0,
                          "fhaupfrontPremiumAmount": 0,
                          "investorEntityIndex": 0,
                          "investorEntityName": "string",
                          "loanTermMonths": 0,
                          "loanTypeName": "string",
                          "lockPeriod": 0,
                          "margin": 0,
                          "miannualPremiumAmount": 0,
                          "mimonthlyPremiumAmount": 0,
                          "mimonthlyPremiumPercent": 0,
                          "mirequiredForLoan": "string",
                          "originationApr": 0,
                          "originationPandI": 0,
                          "originationTotalClosingCost": 0,
                          "price": 0,
                          "rate": 0,
                          "totalMarginAdjustment": 0,
                          "totalPriceAdjustment": 0,
                          "totalRateAdjustment": 0,
                          "totalSrpadjustment": 0,
                          "discount": 0,
                          "rebate": 0,
                          "totalCredit": 0,
                          "loanTermYears": 0,
                          "armFixedTermYears": 0,
                          "totalPayment": 0,
                          "priceStatus": "string",
                          "isAgentSelected": true,
                          "adjustedApr": 0,
                          "adjustedFee": 0,
                          "armmargin": 0,
                          "armindexValue": 0,
                          "armsubsequentChangePeriod": "string",
                          "points": 0,
                          "pointsCost": 0,
                          "closingCost": 0,
                          "pricingRequest": "string",
                          "pricingResultFees": [
                            {
                              "id": 0,
                              "pricingResultId": 0,
                              "amount": 0,
                              "description": "string",
                              "isOrigination": true,
                              "points": 0,
                              "type": "string",
                              "pricingResult": "string"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                "opportunityType": {
                  "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                  "name": "string",
                  "shortName": "string",
                  "displayOrder": 0
                }
              },
              "opportunityType": {
                "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                "name": "string",
                "shortName": "string",
                "displayOrder": 0
              },
              "adjustedApr": 0,
              "adjustedFee": 0
            }
          ]);
    }

    //#endregion opportunities


    //#region Loan App Data
    getLoanApplicationFieldsAsTS(): LgvFormlyModel.Object[] {
    
        return [
            {
                "props": {
                    "label": "Getting Started",
                    "icon": "plus"
                },
                "fieldGroup": [
                    {
                        "props": { "label": "Loan Information" },
                        "fieldGroupClassName": "row",
                        "fieldGroup": [
                            {
                                "key": "loanApp.loanInfo.purpose",
                                "type": "select",
                                "className": "col-12",
                                "props": {
                                    "label": "Loan Purpose",
                                    "options": [
                                        {
                                            "label": "Refinance",
                                            "value": "Refinance"
                                        },
                                        {
                                            "label": "Purchase",
                                            "value": "Purchase"
                                        }
                                    ],
                                    "required": true
                                }
                            },
                            {
                                "key": "loanApp.loanInfo.occupancy",
                                "type": "select",
                                "className": "col-12",
                                "props": {
                                    "label": "Occupancy",
                                    "options": [
                                        {
                                            "label": "Investment",
                                            "value": "Investment"
                                        },
                                        {
                                            "label": "PrimaryResidence",
                                            "value": "PrimaryResidence"
                                        },
                                        {
                                            "label": "SecondHome",
                                            "value": "SecondHome"
                                        },
                                        {
                                            "label": "OtherInvestment",
                                            "value": "OtherInvestment"
                                        },
                                        {
                                            "label": "PrimaryResidence",
                                            "value": "PrimaryResidence"
                                        },
                                        {
                                            "label": "SecondHome",
                                            "value": "SecondHome"
                                        },
                                        {
                                            "label": "Other",
                                            "value": "Other"
                                        }
                                    ],
                                    "required": true
                                }
                            },

                            {
                                "expressions": {
                                    "hide": "!(model?.loanApp?.loanInfo?.purpose === \"Purchase\")"
                                },
                                "key": "loanApp.loanInfo.purchasePrice",
                                "type": "input",
                                "className": "col-12 col-md-6",
                                "props": {
                                    "label": "Purchase Price",
                                    "placeholder": "Purchase Price",
                                    "required": true
                                }
                            },
                            {
                                "expressions": {
                                    "hide": "!(model?.loanApp?.loanInfo?.purpose === \"Purchase\")"
                                },
                                "type": "input",
                                "className": "col-9",
                                "props": {
                                    "label": "Down Payment",
                                    "placeholder": "Down Payment",
                                    "required": true
                                }
                            },
                            {
                                "expressions": {
                                    "hide": "!(model?.loanApp?.loanInfo?.purpose === \"Purchase\")"
                                },
                                "type": "input",
                                "className": "col-3",
                                "props": {
                                    "label": "Down Pct",
                                    "placeholder": "Down Pct",
                                    "required": true
                                }
                            },
                            {
                                "key": "loanApp.loanInfo.loanAmount",
                                "type": "input",
                                "className": "col-12",
                                "props": {
                                    "label": "Loan Amount",
                                    "placeholder": "Loan Amount",
                                    "required": true
                                }
                            },
                            {
                                "expressions": {
                                    "hide": "!(model?.loanApp?.loanInfo?.purpose === \"Purchase\")"
                                },
                                "key": "loanApp.loanInfo.customFields.quotedRate",
                                "type": "radio",
                                "className": "col-12",
                                "props": {
                                    "label": "Have you been quoted any rate?",
                                    "placeholder": "Have you been quoted any rate?",
                                    "required": true,
                                    "options": [
                                        {
                                            "label": "Yes",
                                            "value": "Yes"
                                        },
                                        {
                                            "label": "No",
                                            "value": "No"
                                        }
                                    ]
                                }
                            },
                            {
                                "expressions": {
                                    "hide": "!(model?.loanApp?.loanInfo?.purpose === \"Purchase\")"
                                },
                                "key": "loanApp.loanInfo.customFields.lockingSoon",
                                "type": "radio",
                                "className": "col-12",
                                "props": {
                                    "label": "Are you intending to lock a rate soon?",
                                    "placeholder": "Are you intending to lock a rate soon?",
                                    "required": true,
                                    "options": [
                                        {
                                            "label": "No",
                                            "value": "No"
                                        },
                                        {
                                            "label": "30 days",
                                            "value": "30 days"
                                        },
                                        {
                                            "label": "60 days",
                                            "value": "60 days"
                                        },
                                        {
                                            "label": "90 days",
                                            "value": "90 days"
                                        }
                                    ]
                                }
                            },
                            {
                                "expressions": {
                                    "hide": "!(model?.loanApp?.loanInfo?.purpose === \"Refinance\")"
                                },
                                "key": "loanApp.loanInfo.customFields.removeBorrower",
                                "type": "radio",
                                "className": "col-12",
                                "props": {
                                    "label": "Are you planning to add or remove a borrower from a loan?",
                                    "placeholder": "Are you planning to add or remove a borrower from a loan?",
                                    "required": true,
                                    "options": [
                                        {
                                            "label": "Yes",
                                            "value": "Yes"
                                        },
                                        {
                                            "label": "No",
                                            "value": "No"
                                        }
                                    ]
                                }
                            },
                            {
                                "expressions": {
                                    "hide": "!(model?.loanApp?.loanInfo?.purpose === \"Refinance\")"
                                },
                                "key": "loanApp.loanInfo.customFields.refinancedLast12Months",
                                "type": "radio",
                                "className": "col-12",
                                "props": {
                                    "label": "Have you refinanced in the last 12 months?",
                                    "placeholder": "Have you refinanced in the last 12 months?",
                                    "required": true,
                                    "options": [
                                        {
                                            "label": "Yes",
                                            "value": "Yes"
                                        },
                                        {
                                            "label": "No",
                                            "value": "No"
                                        }
                                    ]
                                }
                            },
                            {
                                "expressions": {
                                    "hide": "!(model?.loanApp?.loanInfo?.purpose === \"Refinance\")"
                                },
                                "key": "loanApp.loanInfo.customFields.lateLast12Months",
                                "type": "radio",
                                "className": "col-12",
                                "props": {
                                    "label": "Have you been late on the mortgage in the last 12 months?",
                                    "placeholder": "Have you been late on the mortgage in the last 12 months?",
                                    "required": true,
                                    "options": [
                                        {
                                            "label": "Yes",
                                            "value": "Yes"
                                        },
                                        {
                                            "label": "No",
                                            "value": "No"
                                        }
                                    ]
                                }
                            }


                        ]
                    },
                    {
                        "props": { "label": "Property Address" },
                        "fieldGroupClassName": "row",
                        "fieldGroup": [
                            {
                                "key": "loanApp.subjectPropertyAddress.city",
                                "type": "input",
                                "className": "col-12 col-lg-7 strong",
                                "props": {
                                    "label": "City",
                                    "placeholder": "City",
                                    "required": true
                                }
                            },
                            {
                                "key": "loanApp.subjectPropertyAddress.state",
                                "type": "input",
                                "className": "col-6 col-lg-2",
                                "props": {
                                    "label": "State",
                                    "placeholder": "State",
                                    "required": true,
                                    "maxLength": 2
                                }
                            },
                            {
                                "key": "loanApp.subjectPropertyAddress.zipCode",
                                "type": "input",
                                "className": "col-6 col-lg-3",
                                "props": {
                                    "label": "Zip",
                                    "placeholder": "Zip",
                                    "required": true
                                }
                            }
                        ]
                    }
                ]
            },
            {
                "props": {
                    "label": "About You",
                    "icon": "cog"
                },
                "fieldGroup": [
                    {
                        "props": { "label": "Borrower Details" },
                        "fieldGroupClassName": "row",
                        "fieldGroup": [
                            {
                                "type": "input",
                                "className": "col-12 col-md-6",
                                "key": "loanApp.borrower.firstName",
                                "props": {
                                    "label": "First Name",
                                    "placeholder": "First Name",
                                    "required": true
                                }
                            },
                            {
                                "type": "input",
                                "className": "col-12 col-md-6",
                                "key": "loanApp.borrower.lastName",
                                "props": {
                                    "label": "Last Name",
                                    "placeholder": "Last Name"
                                }
                            }
                        ]
                    },
                    {
                        "props": { "label": "Address History" },
                        "fieldGroupClassName": "row",
                        "fieldGroup": [
                            {
                                "key": "loanApp.borrower.address",
                                "type": "input",
                                "props": {
                                    "label": "Address",
                                    "placeholder": "Address",
                                    "required": true
                                }
                            },
                            {
                                "key": "loanApp.borrower.city",
                                "type": "input",
                                "className": "col-7 strong",
                                "props": {
                                    "label": "City",
                                    "placeholder": "City",
                                    "required": true
                                }
                            },
                            {
                                "key": "loanApp.borrower.state",
                                "type": "input",
                                "className": "col-2",
                                "props": {
                                    "label": "State",
                                    "placeholder": "State",
                                    "required": true
                                }
                            },
                            {
                                "key": "loanApp.borrower.zip",
                                "type": "input",
                                "className": "col-3",
                                "props": {
                                    "label": "Zip",
                                    "placeholder": "Zip",
                                    "required": true
                                }
                            }
                        ]
                    }
                ]
            }
        ];

    }
    //#region Loan App Data




}

